module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 71);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(58);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./global-styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./global-styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function () {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for (var i = 0; i < this.length; i++) {
			var item = this[i];
			if (item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseElement = function () {
    function BaseElement(meister) {
        _classCallCheck(this, BaseElement);

        this.meister = meister;
        this.isMobile = this.meister.browser.isMobile;

        this.element = null;

        this.eventStore = [];

        if (this.onItemLoaded) {
            this.on('itemLoaded', this.onItemLoaded.bind(this));
        }

        if (this.onItemUnloaded) {
            this.on('itemUnloaded', this.onItemUnloaded.bind(this));
        }
    }

    _createClass(BaseElement, [{
        key: 'on',
        value: function on(hook, handler) {
            var _eventStore;

            (_eventStore = this.eventStore).push.apply(_eventStore, _toConsumableArray(this.meister.on(hook, handler, this.constructor.name)));
        }
    }, {
        key: 'one',
        value: function one(hook, block, handler) {
            this.eventStore.push(this.meister.one(hook, block, handler, this.constructor.name));
        }
    }, {
        key: 'classListAdd',
        value: function classListAdd(element) {
            for (var _len = arguments.length, classNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                classNames[_key - 1] = arguments[_key];
            }

            classNames.forEach(function (className) {
                if (className) {
                    element.classList.add(className);
                }
            });

            if (this.isMobile) {
                element.classList.add('pf-mobile');
            }
        }
    }, {
        key: 'classListRemove',
        value: function classListRemove(element) {
            for (var _len2 = arguments.length, classNames = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                classNames[_key2 - 1] = arguments[_key2];
            }

            // eslint-disable-line class-methods-use-this
            classNames.forEach(function (className) {
                element.classList.remove(className);
            });
        }
    }, {
        key: 'getNode',
        value: function getNode() {
            return this.element;
        }
    }]);

    return BaseElement;
}();

exports.default = BaseElement;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var createClassNameString = function createClassNameString() {
    for (var _len = arguments.length, classes = Array(_len), _key = 0; _key < _len; _key++) {
        classes[_key] = arguments[_key];
    }

    return classes.reduce(function (classArray, className) {
        if (className) {
            return classArray.concat(className);
        }

        return classArray;
    }, []).join(' ');
};

exports.default = createClassNameString;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
* @constant
* @memberof module:CustomUi
* @type {String}
* @default
*/
var CUSTOM_UI_EVENT_PREFIX = exports.CUSTOM_UI_EVENT_PREFIX = 'ui';

/**
 * @constant
 * @memberof module:CustomUi
 * @type {String}
 * @default
 */
var MEISTER_DATA_ID_ATTR = exports.MEISTER_DATA_ID_ATTR = 'data-mstr-id';

/**
 * @constant
 * @memberof module:CustomUi
 * @type {String}
 * @default
 */
var MEISTER_DATA_EVENTS_ATTR = exports.MEISTER_DATA_EVENTS_ATTR = 'data-mstr-events';

/**
* @constant
* @memberof module:CustomUi
* @type {String}
* @default
 */
var MEISTER_DATA_STANDARD_ATTR = exports.MEISTER_DATA_STANDARD_ATTR = 'data-mstr-standard';

/**
* @constant
* @memberof module:CustomUi
* @type {String}
* @default
 */
var MEISTER_DATA_DIRECTIVE_ATTR = exports.MEISTER_DATA_DIRECTIVE_ATTR = 'data-mstr-directive';

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractNodesWithSelector = extractNodesWithSelector;
exports.replaceNodeWith = replaceNodeWith;
exports.formatValue = formatValue;
/**
 * Returns a list of all child nodes that match the passed selector.
 * @memberof module:CustomUi
 * @param  {HTMLElement} rootNode The root node from which to search for relevant nodes.
 * @return {HTMLElement[]}        Array with nodes that match the selector.
 */
function extractNodesWithSelector(rootNode, selector) {
  return Array.prototype.slice.call(rootNode.querySelectorAll(selector));
}

/**
 * Replace one node with another node.
 * @memberof module:CustomUi
 * @param  {HTMLElement} oldNode Node to be replaced.
 * @param  {HTMLElement} newNode New node to insert.
 * @return {?HTMLElement}        Old node, or null if replacing was not possible.
 */
function replaceNodeWith(oldNode, newNode) {
  if (!oldNode.parentNode) {
    return null;
  }

  return oldNode.parentNode.replaceChild(newNode, oldNode);
}

/**
 * Removes trailing/leading whitespace from a value and makes it lowercase.
 * @memberof module:CustomUi
 * @param  {String} [value] String to be formatted.
 * @return {String}             Formatted value.
 */
function formatValue(value) {
  return value.trim().toLowerCase();
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProtoDirective = function () {
    function ProtoDirective(meister, config) {
        _classCallCheck(this, ProtoDirective);

        this.config = config; // this is htmlUI config!
        this.meister = meister;
    }

    _createClass(ProtoDirective, [{
        key: "unload",
        value: function unload() {// eslint-disable-line class-methods-use-this

        }
    }]);

    return ProtoDirective;
}();

exports.default = ProtoDirective;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(50);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HtmlUi = __webpack_require__(10);

var _HtmlUi2 = _interopRequireDefault(_HtmlUi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _HtmlUi2.default;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _eventNodeFunctions = __webpack_require__(19);

var _standardNodeFunctions = __webpack_require__(20);

var _directiveNodeFunctions = __webpack_require__(17);

var _package = __webpack_require__(70);

var _package2 = _interopRequireDefault(_package);

var _defaultTheme = __webpack_require__(13);

var _defaultTheme2 = _interopRequireDefault(_defaultTheme);

var _runControllers = __webpack_require__(12);

var _runControllers2 = _interopRequireDefault(_runControllers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /** @module HtmlUi */


/**
 * Returns DOM Node that is inserted in the DOM but not visibly.
 * @return {DOMNode}
 */
var getTemplateWrapper = function getTemplateWrapper() {
    var templateElementWrapper = document.createElement('div');
    templateElementWrapper.style.display = 'none';
    templateElementWrapper.style.visibility = 'hidden';

    var templateElement = document.createElement('div');
    templateElementWrapper.appendChild(templateElement);

    document.body.appendChild(templateElementWrapper);

    return templateElement;
};

/**
 * Plugin that can be used to supply your own HTMLElements that make up the ui. By specifying
 * data-attributes you can customize the functionality of the ui.
 * @memberof module:HtmlUi
 */

var HtmlUi = function (_Meister$Ui) {
    _inherits(HtmlUi, _Meister$Ui);

    /**
     * Create a new HtmlUi.
     * @memberof module:HtmlUi
     * @param {Object} config Configuration for the plugin.
     * @param {Meister} meister Meister instance which is instantiating a new HtmlUi.
     */
    function HtmlUi(config, meister) {
        var _ret2;

        _classCallCheck(this, HtmlUi);

        var _this = _possibleConstructorReturn(this, (HtmlUi.__proto__ || Object.getPrototypeOf(HtmlUi)).call(this, config, meister));

        _this.hiddenClassName = _this.config.hiddenClassName || 'mstr-hide-controls';
        _this.directives = [];

        if (!_this.config.ui) {
            _this.insertStringTemplate((0, _defaultTheme2.default)());
        } else if (_this.meister.utils.isDOMNode(_this.config.ui)) {
            _this.element = _this.config.ui;
            _this.processTemplate();
        } else if (typeof _this.config.ui === 'string') {
            // insert string template configured by user
            _this.insertStringTemplate(_this.config.ui);
        } else {
            var _ret;

            console.warn('Unable to render a UI template');
            return _ret = [], _possibleConstructorReturn(_this, _ret);
        }

        // Consistent return.
        return _ret2 = _this, _possibleConstructorReturn(_this, _ret2);
    }

    /**
     * Name of the plugin that is used for registering it.
     * @return {String}
     */


    _createClass(HtmlUi, [{
        key: 'insertStringTemplate',


        /**
         * Inserts and handles a template defined as string
         * @param {String} template
         */
        value: function insertStringTemplate(template) {
            var wrapper = getTemplateWrapper();
            wrapper.innerHTML = template;

            // Get rid of the wrapping element.
            this.element = wrapper.firstChild;

            this.processTemplate();
            this.draw();
        }

        /**
         * Replace marked nodes with their StandardUi equivalents, and register events on the specified nodes.
         */

    }, {
        key: 'processTemplate',
        value: function processTemplate() {
            var _this2 = this;

            (0, _standardNodeFunctions.extractStandardNodes)(this.element).forEach((0, _standardNodeFunctions.createLoadStandardElement)(this.meister, this.config.standard));
            (0, _eventNodeFunctions.extractEventNodes)(this.element).forEach((0, _eventNodeFunctions.createRegisterDataEvents)(this.meister, this.config.registeredCallback));
            (0, _directiveNodeFunctions.extractDirectiveNodes)(this.element).forEach(function (element) {
                var _directives;

                var attachDirective = (0, _directiveNodeFunctions.createAttachDirective)(_this2.meister, _this2.config);

                (_directives = _this2.directives).push.apply(_directives, _toConsumableArray(attachDirective(element)));
            });
            // set events
            this.meister.on('uiEvent:hideControls', this.hideControls.bind(this));
            this.meister.on('uiEvent:showControls', this.showControls.bind(this));
            this.meister.on('uiEvent:hideCursor', this.hideCursor.bind(this));
            this.meister.on('uiEvent:showCursor', this.showCursor.bind(this));

            (0, _runControllers2.default)(this.meister);
        }

        /**
         * Insert the Ui into the DOM.
         */

    }, {
        key: 'draw',
        value: function draw() {
            if (!this.element) {
                return;
            }

            this.controlsWrapper.appendChild(this.element);
        }
    }, {
        key: 'hideControls',
        value: function hideControls() {
            if (this.element) this.element.classList.add(this.hiddenClassName);
        }
    }, {
        key: 'showControls',
        value: function showControls() {
            if (this.element) this.element.classList.remove(this.hiddenClassName);
        }
    }, {
        key: 'hideCursor',
        value: function hideCursor() {
            this.meister.container.style.cursor = 'none';
        }
    }, {
        key: 'showCursor',
        value: function showCursor() {
            this.meister.container.style.cursor = 'auto';
        }
    }, {
        key: 'unload',
        value: function unload() {
            _get(HtmlUi.prototype.__proto__ || Object.getPrototypeOf(HtmlUi.prototype), 'unload', this).call(this);
            this.directives.forEach(function (directive) {
                directive.unload();
            });
        }
    }], [{
        key: 'pluginName',
        get: function get() {
            return 'HtmlUi';
        }
    }, {
        key: 'pluginVersion',
        get: function get() {
            return _package2.default.version;
        }
    }]);

    return HtmlUi;
}(Meister.Ui);

Meister.registerPlugin(HtmlUi.pluginName, HtmlUi);
exports.default = HtmlUi;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdWrapperController = function () {
    function AdWrapperController(meister) {
        _classCallCheck(this, AdWrapperController);

        this.meister = meister;
    }

    _createClass(AdWrapperController, [{
        key: 'onAdBreakStarted',
        value: function onAdBreakStarted() {
            this.meister.adWrapper.classList.remove('pf-ui-element-hidden');

            // iOS cannot handle visibility:hidden very well.
            // So we make an exception for that and use display instead on this element.
            if (this.meister.browser.isiOS) {
                this.meister.adWrapper.style.display = 'block';
            }
        }
    }, {
        key: 'onAdBreakEnded',
        value: function onAdBreakEnded() {
            this.meister.adWrapper.classList.add('pf-ui-element-hidden');

            // iOS cannot handle visibility:hidden very well.
            // So we make an exception for that and use display instead on this element.
            if (this.meister.browser.isiOS) {
                this.meister.adWrapper.style.display = 'none';
            }
        }
    }, {
        key: 'run',
        value: function run() {
            var _this = this;

            this.meister.on(['adBreakEnded', 'itemUnloaded'], function () {
                return _this.onAdBreakEnded();
            });
            this.meister.on('adBreakStarted', function () {
                return _this.onAdBreakStarted();
            });
        }
    }]);

    return AdWrapperController;
}();

exports.default = AdWrapperController;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = runControllers;

var _AdWrapperController = __webpack_require__(11);

var _AdWrapperController2 = _interopRequireDefault(_AdWrapperController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Run all controllers that need to be run regardless of
 * what the UI looks like.
 *
 * @export
 * @param {Meister} meister
 */
function runControllers(meister) {
  var adWrapperController = new _AdWrapperController2.default(meister);
  adWrapperController.run();
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styles = __webpack_require__(59);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultTheme = function defaultTheme() {
    return '<div class="mstr-container" data-mstr-directive="autoHideShow,togglePlayPauseClick">\n        <div class="mstr-centerbar">\n            <span data-mstr-standard="spinner"></span>\n        </div>\n        <div class="mstr-bottombar">\n            <div class="mstr-items">\n                <div class="mstr-item">\n                    <span data-mstr-standard="playbutton"></span>\n                </div>\n                <div class="mstr-item">\n                    <span data-mstr-standard="playlistpreviousbutton"></span>\n                </div>\n                <div class="mstr-item mstr-item--fill">\n                    <span data-mstr-standard="seekbar"></span>\n                </div>\n                <div class="mstr-item">\n                    <span data-mstr-standard="timedisplay"></span>\n                </div>\n                <div class="mstr-item">\n                    <span data-mstr-standard="playlistnextbutton"></span>\n                </div>\n                <div class="mstr-item">\n                    <span data-mstr-standard="fullscreenbutton"></span>\n                </div>\n                <div class="mstr-item">\n                    <span data-mstr-standard="volumeslider"></span>\n                </div>\n                <div class="mstr-item">\n                    <span data-mstr-standard="qualitybutton"></span>\n                </div>\n            </div>\n        </div>\n    </div>';
}; // eslint-disable-next-line no-unused-vars
exports.default = defaultTheme;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ProtoDirective2 = __webpack_require__(7);

var _ProtoDirective3 = _interopRequireDefault(_ProtoDirective2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @module AutoHideShowControls
* Directive used to autohide the UI. Can be instantiated by setting data-mstr-directive="autoHideShow" on an element.
*/

var TIME_TILL_FADE = 3000;

var AutoHideShowControls = function (_ProtoDirective) {
    _inherits(AutoHideShowControls, _ProtoDirective);

    /**
     * Create a new AutoHideShowControls.
     * @memberof module:HtmlUi
     * @param {Meister} meister Meister instance which is instantiating a new HtmlUi.
     * @param {Object} config Configuration of the HtmlUI Plugin.
     */
    function AutoHideShowControls(meister, config) {
        _classCallCheck(this, AutoHideShowControls);

        var _this = _possibleConstructorReturn(this, (AutoHideShowControls.__proto__ || Object.getPrototypeOf(AutoHideShowControls)).call(this, meister, config));

        if (Number.isFinite(_this.config.timeToFade)) {
            TIME_TILL_FADE = _this.config.timeToFade * 1000;
        }

        // Bind class methods to instance for easier event listener removal.
        _this.onMouseDown = _this.onMouseDown.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);

        _this.mouseTimeout = null;
        _this.controlsTimeout = null;
        _this.isControlsShown = false;

        _this.fixedControls = !!_this.config.fixedControls;
        _this.toggleFixedControls(_this.fixedControls);
        return _this;
    }

    /**
     * Set's the events on the meister-container
     * @param {Boolean} on whether the UI should autohide, can be set by the config-option `fixedControls`
     * @return {null}
     */


    _createClass(AutoHideShowControls, [{
        key: 'toggleFixedControls',
        value: function toggleFixedControls(on) {
            if (on) {
                this.removeEventListeners();
                this.showControls();
                this.showCursor();
            } else {
                this.addEventListeners();
                // Start hide countdown.
                this.mouseTimeout = setTimeout(this.hideCursor.bind(this), TIME_TILL_FADE);
                this.controlsTimeout = setTimeout(this.hideControls.bind(this), TIME_TILL_FADE);
            }
        }
    }, {
        key: 'removeEventListeners',
        value: function removeEventListeners() {
            this.meister.container.removeEventListener('mousedown', this.onMouseDown);
            this.meister.container.removeEventListener('touchstart', this.onMouseDown);
            this.meister.container.removeEventListener('mousemove', this.onMouseMove);
            this.meister.container.removeEventListener('touchmove', this.onMouseMove);
            this.meister.container.removeEventListener('mouseleave', this.onMouseLeave);
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            this.meister.container.addEventListener('mousedown', this.onMouseDown);
            this.meister.container.addEventListener('touchstart', this.onMouseDown);
            this.meister.container.addEventListener('mousemove', this.onMouseMove);
            this.meister.container.addEventListener('touchmove', this.onMouseMove);
            this.meister.container.addEventListener('mouseleave', this.onMouseLeave);
        }

        /**
         * Callback for hideCursor-Event, triggers a Meister-event
         * @return {null}
         */

    }, {
        key: 'hideCursor',
        value: function hideCursor() {
            if (this.dragging) {
                return;
            }
            this.meister.trigger('uiEvent:hideCursor', {});
        }

        /**
         * Callback for showCursor-Event, triggers a Meister-event
         * @return {null}
         */

    }, {
        key: 'showCursor',
        value: function showCursor() {
            this.meister.trigger('uiEvent:showCursor', {});
        }

        /**
         * Callback for hideControls-Event, triggers a Meister-event
         * @return {null}
         */

    }, {
        key: 'hideControls',
        value: function hideControls() {
            if (this.dragging || !this.meister.playing) {
                return;
            }
            this.meister.trigger('uiEvent:hideControls', {});
        }

        /**
         * Callback for showControls-Event, triggers a Meister-event
         * @return {null}
         */

    }, {
        key: 'showControls',
        value: function showControls() {
            this.meister.trigger('uiEvent:showControls', {});
        }

        /* Events */

    }, {
        key: 'onMouseDown',
        value: function onMouseDown() {
            this.dragging = true;
            window.addEventListener('mouseup', this.onMouseUp);
            window.addEventListener('touchend', this.onMouseUp);
        }
    }, {
        key: 'onMouseUp',
        value: function onMouseUp() {
            this.dragging = false;
            // Fake mouse movement
            this.onMouseMove();

            window.removeEventListener('mouseup', this.onMouseUp);
            window.removeEventListener('touchend', this.onMouseUp);
        }
    }, {
        key: 'onMouseMove',
        value: function onMouseMove() {
            clearTimeout(this.mouseTimeout);
            clearTimeout(this.controlsTimeout);

            this.showControls();
            this.showCursor();

            this.mouseTimeout = setTimeout(this.hideCursor.bind(this), TIME_TILL_FADE);
            this.controlsTimeout = setTimeout(this.hideControls.bind(this), TIME_TILL_FADE);
        }
    }, {
        key: 'onMouseLeave',
        value: function onMouseLeave() {
            clearTimeout(this.mouseTimeout);
            clearTimeout(this.controlsTimeout);

            this.hideControls();
            this.showCursor();
        }
    }, {
        key: 'unload',
        value: function unload() {
            this.removeEventListeners();
            if (this.mouseTimeout) clearTimeout(this.mouseTimeout);
            if (this.controlsTimeout) clearTimeout(this.controlsTimeout);
            window.removeEventListener('mouseup', this.onMouseUp);
            window.removeEventListener('touchend', this.onMouseUp);
        }
    }]);

    return AutoHideShowControls;
}(_ProtoDirective3.default);

var autoHideShow = function autoHideShow(meister, config) {
    return new AutoHideShowControls(meister, config);
};

exports.default = autoHideShow;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ProtoDirective2 = __webpack_require__(7);

var _ProtoDirective3 = _interopRequireDefault(_ProtoDirective2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TogglePlayPauseClick = function (_ProtoDirective) {
    _inherits(TogglePlayPauseClick, _ProtoDirective);

    function TogglePlayPauseClick(meister, config, element) {
        _classCallCheck(this, TogglePlayPauseClick);

        var _this = _possibleConstructorReturn(this, (TogglePlayPauseClick.__proto__ || Object.getPrototypeOf(TogglePlayPauseClick)).call(this, meister, config, element));

        _this.isLive = false;

        // Taken from StandardUi
        _this.meister.config.playPauseOnScreenClick = _this.meister.config.playPauseOnScreenClick === undefined ? true : _this.meister.config.playPauseOnScreenClick;

        _this.onElementClick = _this.onElementClick.bind(_this);
        _this.element = element;

        _this.element.addEventListener('click', _this.onElementClick);

        _this.meister.on('itemTimeInfo', function (timeInfo) {
            _this.isLive = timeInfo.isLive;
        });
        return _this;
    }

    _createClass(TogglePlayPauseClick, [{
        key: 'onElementClick',
        value: function onElementClick(e) {
            // Don't use this directive on mobile devices since these are annoying for users.
            if (this.meister.browser.isMobile) {
                return;
            }

            if (!this.meister.config.playPauseOnScreenClick) {
                return;
            }

            // Ignore clicks on child elements.
            if (e.target !== this.element) {
                return;
            }

            if (this.meister.playing) {
                this.meister.pause(true);
            } else {
                this.meister.play(true);
            }
        }
    }, {
        key: 'unload',
        value: function unload() {
            this.element.removeEventListener(this.onElementClick);
        }
    }]);

    return TogglePlayPauseClick;
}(_ProtoDirective3.default);

exports.default = TogglePlayPauseClick;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createDirective;

var _AutoHideShow = __webpack_require__(14);

var _AutoHideShow2 = _interopRequireDefault(_AutoHideShow);

var _TogglePlayPauseClick = __webpack_require__(15);

var _TogglePlayPauseClick2 = _interopRequireDefault(_TogglePlayPauseClick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createDirective(meister, config, name, element) {
    switch (name) {
        case 'autohideshow':
            return (0, _AutoHideShow2.default)(meister, config, element);
        case 'toggleplaypauseclick':
            return new _TogglePlayPauseClick2.default(meister, config, element);
        default:
            return null;
    }
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.extractDirectiveNodes = extractDirectiveNodes;
exports.createAttachDirective = createAttachDirective;

var _constants = __webpack_require__(5);

var _utilities = __webpack_require__(6);

var _createDirective = __webpack_require__(16);

var _createDirective2 = _interopRequireDefault(_createDirective);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a list of all child nodes that have meister standard data properties.
 * @memberof module:CustomUi
 * @param  {HTMLElement} rootNode The root node from which to search for relevant nodes.
 * @return {HTMLElement[]}        Array with nodes that have the meister standard data property.
 */
function extractDirectiveNodes(rootNode) {
    var nodeArray = (0, _utilities.extractNodesWithSelector)(rootNode, '[' + _constants.MEISTER_DATA_DIRECTIVE_ATTR + ']');

    if (rootNode.getAttribute(_constants.MEISTER_DATA_DIRECTIVE_ATTR)) {
        return nodeArray.concat(rootNode);
    }

    return nodeArray;
}

/**
 * Create a function that can be used to replace nodes with Standard Ui elements.
 * @memberof module:CustomUi
 * @param  {Meister} meister     Meister instance to be used in the event callbacks.
 * @param  {Object} [config={}]  StandardUi config to be used when creating standard components.
 * @return {module:CustomUi~loadStandardElement} Function that can be used to replace nodes with Standard Ui elements.
 */
function createAttachDirective(meister) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    /**
     * Replace nodes with the Standard Ui element specified in MEISTER_DATA_STANDARD_ATTR.
     * @function module:CustomUi~loadStandardElement
     * @param  {HTMLElement} domNode Node with data-mstr-standard that should be replaced with a Standard Ui element.
     */
    return function attachDirective(domNode) {
        var directiveName = (0, _utilities.formatValue)(domNode.getAttribute(_constants.MEISTER_DATA_DIRECTIVE_ATTR));

        // Directives can be comma seperated so you can attach multiple directives to an element.
        var directiveNames = directiveName.split(',');
        var directives = directiveNames.map(function (singleDirectiveName) {
            return (0, _createDirective2.default)(meister, config, singleDirectiveName, domNode);
        });

        return directives;
    };
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomUiElementRegisteredEvent = exports.CustomUiEvent = undefined;

var _constants = __webpack_require__(5);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * An event used as a callback arguments in custom ui events proxying DOM events.
 * @typedef {Object} module:CustomUi~CustomUiEvent
 * @property {Meister} meister - Meister instance from which the event originated.
 * @property {HTMLElement} domNode - Node from which the DOM event originated.
 * @property {String} eventName - The name of the event that originated from meister.
 * @property {String} eventType - The name of the DOM event.
 * @property {Event} domEvent - The original DOM event that was triggered.
 */
var CustomUiEvent =
/**
 * Create a CustomUiEvent.
 * @memberof module:CustomUi
 * @param {Meister} meister Meister instance from which the event originated.
 * @param {HTMLElement} domNode Node from which the DOM event originated.
 * @param {String} eventName The name of the event that originated from meister.
 * @param {String} eventType The name of the DOM event.
 * @param {Event} domEvent The original DOM event that was triggered.
 */
exports.CustomUiEvent = function CustomUiEvent(meister, domNode, eventName, eventType, domEvent) {
  _classCallCheck(this, CustomUiEvent);

  this.eventName = eventName;
  this.eventType = eventType;
  this.event = domEvent;
  this.meister = meister;
  this.element = domNode;
};

/**
 * An event used as a callback argument when all listeners have been attached to a custom DOM element.
 * @typedef {Object} module:CustomUi~CustomUiElementRegisteredEvent
 * @property {Meister} meister - Meister instance from which the event originated.
 * @property {HTMLElement} domNode - Node on which the events were registered.
 * @property {String[]} events - Array with all the events that were registered on the HTMLElement.
 * @property {String} id - The id of the node on which the events were registered.
 */


var CustomUiElementRegisteredEvent =
/**
 * Create a CustomUiElementRegisteredEvent.
 * @memberof module:CustomUi
 * @param {Meister} meister Meister instance from which the event originated.
 * @param {HTMLElement} domNode Node on which the events were registered.
 * @param {String[]} events Array with all the events that were registered on the HTMLElement.
 */
exports.CustomUiElementRegisteredEvent = function CustomUiElementRegisteredEvent(meister, domNode, events) {
  _classCallCheck(this, CustomUiElementRegisteredEvent);

  this.meister = meister;
  this.element = domNode;
  this.events = events;
  this.id = domNode.getAttribute(_constants.MEISTER_DATA_ID_ATTR);
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.extractEventNodes = extractEventNodes;
exports.createRegisterDataEvents = createRegisterDataEvents;

var _constants = __webpack_require__(5);

var _utilities = __webpack_require__(6);

var _eventClasses = __webpack_require__(18);

/**
 * Returns a list of all child nodes that have meister event data properties. Also includes the root node
 * should it have the property.
 * @memberof module:CustomUi
 * @param  {HTMLElement} rootNode The root node from which to search for relevant nodes.
 * @return {HTMLElement[]}        Array with nodes that have the meister event data property.
 */
function extractEventNodes(rootNode) {
    var nodeArray = (0, _utilities.extractNodesWithSelector)(rootNode, '[' + _constants.MEISTER_DATA_EVENTS_ATTR + ']');

    if (rootNode.getAttribute(_constants.MEISTER_DATA_EVENTS_ATTR)) {
        return nodeArray.concat(rootNode);
    }

    return nodeArray;
}

/**
 * Extracts individual strings from a single comma separated string while trimming whitespace and
 * filtering just whitespace entries.
 * @memberof module:CustomUi
 * @param  {String} eventString Comma separated string of event names.
 * @return {String[]}           Array with event names.
 */
function extractEvents(eventString) {
    return eventString.split(',').filter(function (eventName) {
        return !!eventName;
    }) // filter empty entries.
    .map(function (eventName) {
        return eventName.trim();
    }) // remove leading/trailing whitespace.
    .filter(function (eventName) {
        return !!eventName;
    }); // remove entries that were only spaces.
}

/**
 * Callback that is called after all events are registered to an HTMLElement.
 * @callback module:CustomUi~onElementRegistered
 * @param {module:CustomUi~CustomUiElementRegisteredEvent} customUiElementRegisteredEvent
 */

/**
 * Create a function that can be used to map dom events to meister events for html nodes.
 * @memberof module:CustomUi
 * @param  {Meister} meister      Meister instance to be used in the event callbacks.
 * @param  {module:CustomUi~onElementRegistered} [onElementRegistered=()=>{}] Callback to be used when all events have been registered on an HTMLElement.
 * @return {module:CustomUi~registerDataEvents} Function that can be used to register events to an HTMLElement.
 */
function createRegisterDataEvents(meister) {
    var onElementRegistered = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    /**
     * Map events in the MEISTER_DATA_EVENTS_ATTR data attribute to meister events and call a
     * callback when done.
     * @function module:CustomUi~registerDataEvents
     * @param  {HTMLElement} domNode Node with data-mstr-events that need to be mapped to meister custom ui events.
     */
    return function registerDataEvents(domNode) {
        var rawAttributes = domNode.getAttribute(_constants.MEISTER_DATA_EVENTS_ATTR);
        if (!rawAttributes) {
            return;
        }

        var eventsArray = extractEvents(rawAttributes);
        if (eventsArray.length < 1) {
            return;
        }

        var rawDomNodeId = domNode.getAttribute(_constants.MEISTER_DATA_ID_ATTR);
        var domNodeId = rawDomNodeId ? rawDomNodeId + ':' : '';
        var handleName = _constants.CUSTOM_UI_EVENT_PREFIX + ':' + domNodeId;

        eventsArray.forEach(function (eventName) {
            var meisterEventName = '' + handleName + eventName;
            domNode.addEventListener(eventName, function (e) {
                meister.trigger(meisterEventName, new _eventClasses.CustomUiEvent(meister, domNode, meisterEventName, eventName, e));
            });
        });

        onElementRegistered(new _eventClasses.CustomUiElementRegisteredEvent(meister, domNode, eventsArray));
    };
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.extractStandardNodes = extractStandardNodes;
exports.createLoadStandardElement = createLoadStandardElement;

var _constants = __webpack_require__(5);

var _utilities = __webpack_require__(6);

var _createStandardElement = __webpack_require__(35);

var _createStandardElement2 = _interopRequireDefault(_createStandardElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a list of all child nodes that have meister standard data properties.
 * @memberof module:CustomUi
 * @param  {HTMLElement} rootNode The root node from which to search for relevant nodes.
 * @return {HTMLElement[]}        Array with nodes that have the meister standard data property.
 */
function extractStandardNodes(rootNode) {
    return (0, _utilities.extractNodesWithSelector)(rootNode, '[' + _constants.MEISTER_DATA_STANDARD_ATTR + ']');
}

/**
 * Create a function that can be used to replace nodes with Standard Ui elements.
 * @memberof module:CustomUi
 * @param  {Meister} meister     Meister instance to be used in the event callbacks.
 * @param  {Object} [config={}]  StandardUi config to be used when creating standard components.
 * @return {module:CustomUi~loadStandardElement} Function that can be used to replace nodes with Standard Ui elements.
 */
function createLoadStandardElement(meister) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    /**
     * Replace nodes with the Standard Ui element specified in MEISTER_DATA_STANDARD_ATTR.
     * @function module:CustomUi~loadStandardElement
     * @param  {HTMLElement} domNode Node with data-mstr-standard that should be replaced with a Standard Ui element.
     */
    return function loadStandardElement(domNode) {
        var elementName = (0, _utilities.formatValue)(domNode.getAttribute(_constants.MEISTER_DATA_STANDARD_ATTR));
        if (!elementName) {
            return;
        }

        var standardElement = (0, _createStandardElement2.default)(meister, config, elementName);
        if (!standardElement) {
            console.error('No standard element with name \'' + elementName + '\'');
        }

        (0, _utilities.replaceNodeWith)(domNode, standardElement.getNode());
    };
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseElement2 = __webpack_require__(3);

var _BaseElement3 = _interopRequireDefault(_BaseElement2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CaptionsButton = function (_BaseElement) {
    _inherits(CaptionsButton, _BaseElement);

    function CaptionsButton(meister) {
        _classCallCheck(this, CaptionsButton);

        var _this = _possibleConstructorReturn(this, (CaptionsButton.__proto__ || Object.getPrototypeOf(CaptionsButton)).call(this, meister));

        _this.element = document.createElement('div');
        _this.classListAdd(_this.element, 'pf-ui-element', 'pf-ui-element-right', 'pf-ui-element-active');
        _this.classListAdd(_this.element, 'pf-icon', 'pf-icon_icCc');
        _this.classListAdd(_this.element, 'pf-ui-element-hidden');

        _this.captionSelector = document.createElement('div');
        _this.classListAdd(_this.captionSelector, 'pf-quality-selector', 'hidden');

        _this.meister.controlsWrapper.appendChild(_this.captionSelector);

        _this.element.addEventListener('click', _this.onClick.bind(_this));

        _this.captions = null;
        _this.on('itemLoaded', _this.onItemLoaded.bind(_this));

        // Store this eventfunction in the instance for easier removal.
        _this.hide = function () {
            _this.classListAdd(_this.captionSelector, 'hidden');
            document.body.removeEventListener('click', _this.hide);
        };
        return _this;
    }

    _createClass(CaptionsButton, [{
        key: 'onItemUnloaded',
        value: function onItemUnloaded() {
            this.captionSelector.innerHTML = '';
            this.captions = null;

            this.classListAdd(this.element, 'pf-ui-element-hidden');
        }
    }, {
        key: 'onClick',
        value: function onClick(e) {
            // TODO: Perhaps do this later?
            e.stopPropagation();

            // Show/hide menu when the button is clicked.
            if (!e.target.hasAttribute('lang')) {
                if (this.captionSelector.classList.contains('hidden')) {
                    this.show();
                } else {
                    this.hide();
                }

                return;
            }

            // Element has attribute lang, must be a language option
            var newLang = e.target.getAttribute('lang');
            this.selectLang(newLang);
            this.hide();
        }
    }, {
        key: 'show',
        value: function show() {
            this.classListRemove(this.captionSelector, 'hidden');
            document.body.addEventListener('click', this.hide);
        }
    }, {
        key: 'onItemLoaded',
        value: function onItemLoaded(e) {
            var _this2 = this;

            if (!e.item || !e.item.captions) return;

            // Slice to make a copy of the array;
            if (!Array.isArray(e.item.captions)) {
                this.captions = [e.item.captions];
            } else {
                this.captions = e.item.captions.slice(0).sort(function (a, b) {
                    var titleA = a.title.toUpperCase();
                    var titleB = b.title.toUpperCase();
                    if (titleA < titleB) return -1;
                    if (titleA > titleB) return 1;

                    return 0;
                });
            }

            // Add an option to turn cc off.
            this.captions.push({ title: this.meister.Localization.get('NONE'), lang: 'none' });

            this.classListRemove(this.element, 'pf-ui-element-hidden');

            this.captions.forEach(function (caption) {
                var language = caption.title;
                var code = caption.lang;
                // eslint-disable-next-line no-param-reassign
                caption.option = _this2.createOption(language, code);
            });

            this.classListRemove(this.element, 'pf-ui-element-hidden');
        }
    }, {
        key: 'createOption',
        value: function createOption(language, code) {
            var _this3 = this;

            var languageOption = document.createElement('div');
            languageOption.classList.add('pf-quality-option');
            languageOption.classList.add('pf-ui-element-active');

            languageOption.textContent = language.charAt(0).toUpperCase() + language.toLowerCase().slice(1);

            languageOption.setAttribute('lang', code);

            languageOption.selected = document.createElement('div');
            languageOption.selected.classList.add('pf-quality-option-select');
            languageOption.selected.classList.add('pf-icon');
            // Check for mobile.
            if (this.isMobile) languageOption.selected.classList.add('pf-mobile');
            languageOption.appendChild(languageOption.selected);

            this.captionSelector.appendChild(languageOption);

            languageOption.addEventListener('click', function (e) {
                return _this3.onClick(e);
            });

            return languageOption;
        }
    }, {
        key: 'selectLang',
        value: function selectLang(languageCode) {
            this.captions.forEach(function (caption) {
                caption.option.selected.classList.remove('pf-icon_icCheck');
            });

            if (languageCode === 'none') {
                this.meister.trigger('requestCaptions', { newLanguage: 'none' });
                return;
            }

            var newCaption = this.captions.find(function (caption) {
                return caption.lang === languageCode;
            });

            newCaption.option.selected.classList.add('pf-icon_icCheck');
            this.meister.trigger('requestCaptions', newCaption);
        }
    }]);

    return CaptionsButton;
}(_BaseElement3.default);

exports.default = CaptionsButton;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseElement2 = __webpack_require__(3);

var _BaseElement3 = _interopRequireDefault(_BaseElement2);

var _styles = __webpack_require__(60);

var _styles2 = _interopRequireDefault(_styles);

var _fullscreen = __webpack_require__(36);

var _fullscreen2 = _interopRequireDefault(_fullscreen);

var _fullscreenExit = __webpack_require__(37);

var _fullscreenExit2 = _interopRequireDefault(_fullscreenExit);

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var fullscreenIconSVG = (0, _fullscreen2.default)();
var fullscreenExitIconSVG = (0, _fullscreenExit2.default)();

var FullscreenButton = function (_BaseElement) {
    _inherits(FullscreenButton, _BaseElement);

    function FullscreenButton(meister) {
        _classCallCheck(this, FullscreenButton);

        var _this = _possibleConstructorReturn(this, (FullscreenButton.__proto__ || Object.getPrototypeOf(FullscreenButton)).call(this, meister));

        _this.element = document.createElement('div');

        _this.classListAdd(_this.element, _globalStyles2.default.uiElement);
        if (_this.meister.config.audioOnly) {
            _this.classListAdd(_this.element, _globalStyles2.default.uiElementHidden);
        } else {
            _this.classListAdd(_this.element, _globalStyles2.default.uiElementActive);
        }

        // default
        _this.classListAdd(_this.element, _globalStyles2.default.icon, _styles2.default.fullscreenIcon);
        _this.element.innerHTML = fullscreenIconSVG;

        _this.element.addEventListener('click', function () {
            return _this.toggleFullscreen();
        });

        _this.on('playerFullscreen', function () {
            return _this.toggleIcon();
        });
        _this.on('playlistMetadata', _this.onPlaylistMetadata.bind(_this));
        return _this;
    }

    _createClass(FullscreenButton, [{
        key: 'onPlaylistMetadata',
        value: function onPlaylistMetadata(item) {
            if (item.mediaType === 'audio') {
                this.classListAdd(this.element, _globalStyles2.default.uiElementHidden);
            }
        }
    }, {
        key: 'toggleIcon',
        value: function toggleIcon() {
            var fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement;

            if (fullscreenElement) {
                this.classListAdd(this.element, _styles2.default.fullscreenExitIcon);
                this.classListRemove(this.element, _styles2.default.fullscreenIcon);
                this.element.innerHTML = fullscreenExitIconSVG;
            } else {
                this.classListAdd(this.element, _styles2.default.fullscreenIcon);
                this.classListRemove(this.element, _styles2.default.fullscreenExitIcon);
                this.element.innerHTML = fullscreenIconSVG;
            }
        }
    }, {
        key: 'toggleFullscreen',
        value: function toggleFullscreen() {
            if (this.meister.isFullscreen) {
                this.meister.cancelFullscreen();
            } else {
                this.meister.requestFullscreen();
            }
        }
    }]);

    return FullscreenButton;
}(_BaseElement3.default);

exports.default = FullscreenButton;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseElement2 = __webpack_require__(3);

var _BaseElement3 = _interopRequireDefault(_BaseElement2);

var _styles = __webpack_require__(61);

var _styles2 = _interopRequireDefault(_styles);

var _play = __webpack_require__(40);

var _play2 = _interopRequireDefault(_play);

var _pause = __webpack_require__(39);

var _pause2 = _interopRequireDefault(_pause);

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var playButtonSvg = (0, _play2.default)();
var pauseButtonSvg = (0, _pause2.default)();

var PlayButton = function (_BaseElement) {
    _inherits(PlayButton, _BaseElement);

    function PlayButton(meister, config) {
        var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'normal';

        _classCallCheck(this, PlayButton);

        var _this = _possibleConstructorReturn(this, (PlayButton.__proto__ || Object.getPrototypeOf(PlayButton)).call(this, meister));

        _this.config = config;
        _this.type = type;

        _this.element = document.createElement('div');
        _this.classListAdd(_this.element, _globalStyles2.default.uiElement, _globalStyles2.default.uiElementActive);

        _this.isLive = false;

        // Default
        _this.classListAdd(_this.element, _styles2.default.button);
        _this.classListAdd(_this.element, _styles2.default.playButton);
        _this.element.innerHTML = playButtonSvg;

        // Register event listeners
        _this.element.addEventListener('click', function () {
            return _this.onClick();
        });

        _this.on('itemTimeInfo', function (timeInfo) {
            return _this.onItemTimeInfo(timeInfo);
        });
        _this.on('playerPlay', function () {
            return _this.toggleIcon();
        });
        _this.on('playerPause', function () {
            return _this.toggleIcon();
        });
        _this.on('itemLoaded', function () {
            return _this.toggleIcon();
        });
        return _this;
    }

    _createClass(PlayButton, [{
        key: 'onItemTimeInfo',
        value: function onItemTimeInfo(timeInfo) {
            this.isLive = timeInfo.isLive;

            if (this.isLive && this.config.disablePauseWithLive && this.meister.playing && this.type === 'normal') {
                this.toggleIcon();
            }
        }
    }, {
        key: 'onClick',
        value: function onClick() {
            if (this.meister.playing) {
                this.meister.pause(true);
            } else {
                this.meister.play(true);
            }
        }
    }, {
        key: 'toggleIcon',
        value: function toggleIcon() {
            if (this.isLive && this.config.disablePauseWithLive && this.meister.playing && this.type === 'normal') {
                this.classListRemove(this.element, _styles2.default.playButton);
                this.classListRemove(this.element, _styles2.default.pauseButton);
                return;
            }

            if (this.meister.playing) {
                this.classListAdd(this.element, _styles2.default.pauseButton);
                this.classListRemove(this.element, _styles2.default.playButton);
                this.element.innerHTML = pauseButtonSvg;
            } else {
                this.classListRemove(this.element, _styles2.default.pauseButton);
                this.classListAdd(this.element, _styles2.default.playButton);
                this.element.innerHTML = playButtonSvg;
            }
        }
    }]);

    return PlayButton;
}(_BaseElement3.default);

exports.default = PlayButton;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PlaylistNextButton = exports.PlaylistPreviousButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseElement3 = __webpack_require__(3);

var _BaseElement4 = _interopRequireDefault(_BaseElement3);

var _styles = __webpack_require__(62);

var _styles2 = _interopRequireDefault(_styles);

var _prev = __webpack_require__(41);

var _prev2 = _interopRequireDefault(_prev);

var _next = __webpack_require__(38);

var _next2 = _interopRequireDefault(_next);

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var prevIconSVG = (0, _prev2.default)();
var nextIconSVG = (0, _next2.default)();

var PlaylistPreviousButton = function (_BaseElement) {
    _inherits(PlaylistPreviousButton, _BaseElement);

    function PlaylistPreviousButton(meister) {
        _classCallCheck(this, PlaylistPreviousButton);

        var _this = _possibleConstructorReturn(this, (PlaylistPreviousButton.__proto__ || Object.getPrototypeOf(PlaylistPreviousButton)).call(this, meister));

        _this.element = document.createElement('div');
        _this.classListAdd(_this.element, _globalStyles2.default.uiElement, _globalStyles2.default.uiElementHidden, _globalStyles2.default.icon, _styles2.default.previousIcon);
        _this.element.innerHTML = prevIconSVG;

        _this.element.addEventListener('click', function () {
            return _this.meister.trigger('playlistPrevious');
        });

        _this.on('playlistInfo', function (playlistInfo) {
            return _this.onPlaylistInfo(playlistInfo);
        });
        return _this;
    }

    _createClass(PlaylistPreviousButton, [{
        key: 'onPlaylistInfo',
        value: function onPlaylistInfo(playlistInfo) {
            // Reset the styles on the buttons.
            this.classListRemove(this.element, _globalStyles2.default.uiElementInactive);

            // Don't show playlist controls when there is no playlist.
            if (playlistInfo.length <= 1) {
                this.classListAdd(this.element, _globalStyles2.default.uiElementHidden);
                return;
            }

            // It's the first item, so can't go back.
            if (playlistInfo.currentIndex === 0) {
                this.classListAdd(this.element, _globalStyles2.default.uiElementInactive);
            }

            // It's the last item, so can't skip to the next item.
            if (playlistInfo.currentIndex >= playlistInfo.length - 1) {
                this.classListAdd(this.element, _globalStyles2.default.uiElementActive);
            }

            // Show the playlist buttons.
            this.classListRemove(this.element, _globalStyles2.default.uiElementHidden);
        }
    }]);

    return PlaylistPreviousButton;
}(_BaseElement4.default);

var PlaylistNextButton = function (_BaseElement2) {
    _inherits(PlaylistNextButton, _BaseElement2);

    function PlaylistNextButton(meister) {
        _classCallCheck(this, PlaylistNextButton);

        var _this2 = _possibleConstructorReturn(this, (PlaylistNextButton.__proto__ || Object.getPrototypeOf(PlaylistNextButton)).call(this, meister));

        _this2.element = document.createElement('div');
        _this2.classListAdd(_this2.element, _globalStyles2.default.uiElement, _globalStyles2.default.uiElementHidden, _globalStyles2.default.icon, _styles2.default.nextIcon);
        _this2.element.innerHTML = nextIconSVG;

        _this2.element.addEventListener('click', function () {
            return _this2.meister.trigger('playlistNext');
        });

        _this2.on('playlistInfo', function (playlistInfo) {
            return _this2.onPlaylistInfo(playlistInfo);
        });
        return _this2;
    }

    _createClass(PlaylistNextButton, [{
        key: 'onPlaylistInfo',
        value: function onPlaylistInfo(playlistInfo) {
            // It's the first item, so can't go back.
            if (playlistInfo.currentIndex === 0) {
                this.classListAdd(this.element, _globalStyles2.default.uiElementActive);
            }

            // It's the last item, so can't skip to the next item.
            if (playlistInfo.currentIndex >= playlistInfo.length - 1) {
                this.classListAdd(this.element, _globalStyles2.default.uiElementInactive);
            }

            // Show the playlist buttons.
            this.classListRemove(this.element, _globalStyles2.default.uiElementHidden);
        }
    }]);

    return PlaylistNextButton;
}(_BaseElement4.default);

exports.PlaylistPreviousButton = PlaylistPreviousButton;
exports.PlaylistNextButton = PlaylistNextButton;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.prepareBitrateOption = prepareBitrateOption;
exports.selectBitrate = selectBitrate;
exports.doesBitrateIndexExist = doesBitrateIndexExist;

var _styles = __webpack_require__(8);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prepareBitrateOption(element, bitrate, index, transform) {
    var qualityOption = element;

    if (bitrate === 'auto') {
        qualityOption.textContent = bitrate;
    } else {
        qualityOption.textContent = transform(bitrate);
    }

    qualityOption.setAttribute('index', index);
}

function selectBitrate(bitrates, index, silent) {
    bitrates.forEach(function (bitrate) {
        if (bitrate.index === index) {
            bitrate.option.classList.add(_styles2.default.isActive);
        } else {
            bitrate.option.classList.remove(_styles2.default.isActive);
        }
    });

    return silent ? null : index;
}

/**
 * Checks if a given index exists in the bitrates list.
 *
 * @export
 * @param {Array.<{index: number, bitrate:number, option:HTMLElement}>} bitrates
 * @param {number} index
 * @returns {boolean}
 */
function doesBitrateIndexExist(bitrates, index) {
    return !!bitrates.find(function (bitrate) {
        return bitrate.index === index;
    });
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseElement2 = __webpack_require__(3);

var _BaseElement3 = _interopRequireDefault(_BaseElement2);

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

var _quality = __webpack_require__(42);

var _quality2 = _interopRequireDefault(_quality);

var _styles = __webpack_require__(8);

var _styles2 = _interopRequireDefault(_styles);

var _bitrate = __webpack_require__(25);

var _resolution = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESOLUTION = 0;
var BITRATE = 1;

var iconSVG = (0, _quality2.default)();

var QualityButton = function (_BaseElement) {
    _inherits(QualityButton, _BaseElement);

    function QualityButton(meister, config) {
        _classCallCheck(this, QualityButton);

        var _this = _possibleConstructorReturn(this, (QualityButton.__proto__ || Object.getPrototypeOf(QualityButton)).call(this, meister));

        _this.config = config;
        _this.isOpen = false;

        _this.element = document.createElement('div');
        _this.classListAdd(_this.element, _globalStyles2.default.uiElement, _globalStyles2.default.uiElementActive, _globalStyles2.default.uiElementHidden, _styles2.default.element);

        _this.iconElement = document.createElement('div');
        _this.iconElement.innerHTML = iconSVG;
        _this.classListAdd(_this.iconElement, _globalStyles2.default.icon, _styles2.default.iconElement);
        _this.element.appendChild(_this.iconElement);

        _this.qualitySelector = document.createElement('div');
        _this.classListAdd(_this.qualitySelector, _styles2.default.qualitySelector, _styles2.default.isClosed);

        _this.element.appendChild(_this.qualitySelector);

        _this.qualitySelectorOptions = document.createElement('div');
        _this.classListAdd(_this.qualitySelectorOptions, _styles2.default.qualitySelectorOptions);
        _this.qualitySelector.appendChild(_this.qualitySelectorOptions);

        _this.bitrates = null;
        _this.on('itemBitrates', function (info) {
            return _this.onItemBitrates(info);
        });

        if (Array.isArray(_this.config.qualityMapping)) {
            _this.qualityMappingMode = true;
            _this.qualityMapping = _this.config.qualityMapping.map(_resolution.expandQualityMapping);
        }

        // set event listeners
        _this.iconElement.addEventListener('click', function () {
            return _this.toggleOpen();
        });
        _this.qualitySelectorOptions.addEventListener('click', function (e) {
            return _this.onOptionClick(e);
        });
        return _this;
    }

    _createClass(QualityButton, [{
        key: 'onItemUnloaded',
        value: function onItemUnloaded() {
            // Clear any previous bitrates that were present.
            this.qualitySelectorOptions.innerHTML = '';
            this.bitrates = null;

            this.classListAdd(this.element, _globalStyles2.default.uiElementHidden);
        }
    }, {
        key: 'setOpen',
        value: function setOpen() {
            this.classListAdd(this.qualitySelector, _styles2.default.isOpen);
            this.classListRemove(this.qualitySelector, _styles2.default.isClosed);

            this.isOpen = true;
        }
    }, {
        key: 'setClose',
        value: function setClose() {
            this.classListAdd(this.qualitySelector, _styles2.default.isClosed);
            this.classListRemove(this.qualitySelector, _styles2.default.isOpen);

            this.isOpen = false;
        }
    }, {
        key: 'toggleOpen',
        value: function toggleOpen() {
            if (this.isOpen) {
                this.setClose();
            } else {
                this.setOpen();
            }
        }
    }, {
        key: 'onOptionClick',
        value: function onOptionClick(e) {
            // TODO: Perhaps do this later?
            e.stopPropagation();

            // Show/hide menu when the button is clicked.
            if (!e.target.hasAttribute('index') && !e.target.mapping) {
                if (this.qualitySelector.classList.contains('hidden')) {
                    this.setOpen();
                } else {
                    this.setClose();
                }

                return;
            }

            // Element has attribute index, must be a bitrate option
            if (e.target.hasAttribute('index')) {
                var newBitrateIndex = parseInt(e.target.getAttribute('index'), 10);
                this.selectOption(newBitrateIndex);
            }

            if (e.target.mapping) {
                var _newBitrateIndex = parseInt(e.target.mapping.bitrates[0].bitrateIndex, 10);
                this.selectOption(_newBitrateIndex);
            }

            this.setClose();
        }
    }, {
        key: 'onItemBitrates',
        value: function onItemBitrates(info) {
            var _this2 = this;

            info.bitrates.sort(function (a, b) {
                return b.bitrate - a.bitrate;
            });
            this.bitrates = info.bitrates;
            this.classListRemove(this.element, _globalStyles2.default.uiElementHidden);

            if (this.qualityMappingMode) {
                this.bitrates = (0, _resolution.prepareResolutionMapping)(this.bitrates, this.qualityMapping);
                this.qualityMapping.forEach(function (mapping) {
                    if (mapping.bitrates.length < 1) {
                        if (_this2.meister.config.debug) console.error('No bitrates available for this mapping', mapping);
                    } else {
                        // eslint-disable-next-line
                        mapping.option = _this2.createOption({
                            type: RESOLUTION,
                            mapping: mapping
                        });
                    }
                });
            } else {
                this.bitrates.forEach(function (bitrateInfo) {
                    // A bitrate of 0 means auto quality.
                    var bitrate = bitrateInfo.bitrate === 0 ? 'auto' : bitrateInfo.bitrate;
                    // eslint-disable-next-line
                    bitrateInfo.option = _this2.createOption({
                        type: BITRATE,
                        bitrate: bitrate,
                        index: bitrateInfo.index
                    });
                });
            }

            // parseInt with null will return NaN, just like string with not a numeric value.
            var savedBitrateIndex = parseInt(localStorage.getItem('meister_bitrateIndex'), 10);
            var bitrateIndexExists = (0, _bitrate.doesBitrateIndexExist)(this.bitrates, savedBitrateIndex);

            if (!Number.isNaN(savedBitrateIndex) && bitrateIndexExists) {
                this.selectOption(savedBitrateIndex, false);
            } else {
                this.selectOption(info.currentIndex, true);
            }
        }
    }, {
        key: 'createOption',
        value: function createOption(optionOpts) {
            var qualityOption = document.createElement('div');
            this.classListAdd(qualityOption, _styles2.default.qualitySelectorOption);

            // When no index is passed we're dealing with resolution mapping.
            if (optionOpts.type === BITRATE) {
                var transform = this.config.bitrateToResolution ? this.config.bitrateToResolution : this.meister.utils.bitrateToResolution;

                (0, _bitrate.prepareBitrateOption)(qualityOption, optionOpts.bitrate, optionOpts.index, transform);
            } else if (optionOpts.type === RESOLUTION) {
                (0, _resolution.prepareResolutionOption)(qualityOption, optionOpts.mapping);
            }

            this.qualitySelectorOptions.appendChild(qualityOption);

            return qualityOption;
        }
    }, {
        key: 'selectOption',
        value: function selectOption(index) {
            var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            /** @type {number} */
            var bitrateIndex = null;

            if (this.qualityMappingMode) {
                bitrateIndex = (0, _resolution.selectResolution)(this.qualityMapping, index, silent);
            } else {
                bitrateIndex = (0, _bitrate.selectBitrate)(this.bitrates, index, silent);
            }

            if (Number.isFinite(bitrateIndex)) {
                this.meister.trigger('requestBitrate', {
                    bitrateIndex: bitrateIndex
                });

                localStorage.setItem('meister_bitrateIndex', bitrateIndex.toString());
            }
        }
    }]);

    return QualityButton;
}(_BaseElement3.default);

exports.default = QualityButton;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.expandQualityMapping = expandQualityMapping;
exports.prepareResolutionMapping = prepareResolutionMapping;
exports.prepareResolutionOption = prepareResolutionOption;
exports.selectResolution = selectResolution;
function expandQualityMapping(qualityMapping, index) {
    return {
        index: index,
        bitrates: [],
        from: qualityMapping.from,
        to: qualityMapping.to,
        resolution: qualityMapping.resolution
    };
}

function setResolution(bitrate, bitrateIndex, qualityMapping) {
    var targetMapping = qualityMapping.find(function (mapping) {
        return bitrate > mapping.from && bitrate <= mapping.to;
    });
    if (!targetMapping) {
        console.warn('No resolution found for bitrate: ' + bitrate);
        return;
    }

    targetMapping.bitrates.push({
        bitrate: bitrate,
        bitrateIndex: bitrateIndex
    });
}

function prepareResolutionMapping(bitrates, qualityMapping) {
    bitrates.forEach(function (bitrateInfo) {
        return setResolution(bitrateInfo.bitrate, bitrateInfo.index, qualityMapping);
    });
    return bitrates;
}

function prepareResolutionOption(element, mapping) {
    var qualityOption = element;

    if (!mapping.resolution) {
        console.error('Qualitymapping is missing a resolution-value', mapping);
    }

    qualityOption.textContent = mapping.resolution;
    qualityOption.mapping = mapping;
}

function selectResolution(qualityMapping, index) {
    var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    qualityMapping.forEach(function (mapping) {
        if (!mapping.option) {
            return;
        }

        var hasBitrate = !!mapping.bitrates.find(function (bitrate) {
            return bitrate.bitrateIndex === index;
        });
        if (hasBitrate) {
            mapping.option.selected.classList.add('pf-icon_icCheck');
        } else {
            mapping.option.selected.classList.remove('pf-icon_icCheck');
        }
    });

    return silent ? null : index;
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseElement2 = __webpack_require__(3);

var _BaseElement3 = _interopRequireDefault(_BaseElement2);

var _SeekbarPreview = __webpack_require__(29);

var _SeekbarPreview2 = _interopRequireDefault(_SeekbarPreview);

var _styles = __webpack_require__(63);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function updateBar(element, percentage) {
    element.style.webkitTransform = 'scaleX(' + percentage + ')'; //eslint-disable-line
    element.style.transform = 'scaleX(' + percentage + ')'; //eslint-disable-line
}

var Seekbar = function (_BaseElement) {
    _inherits(Seekbar, _BaseElement);

    function Seekbar(meister) {
        _classCallCheck(this, Seekbar);

        var _this = _possibleConstructorReturn(this, (Seekbar.__proto__ || Object.getPrototypeOf(Seekbar)).call(this, meister));

        _this.isDragging = false;

        _this.loadedMetadata = false;

        _this.mousedownX = 0;
        _this.pagedownX = 0;

        // wrapper
        _this.element = document.createElement('div');
        _this.classListAdd(_this.element, _styles2.default.wrapper);

        // inner
        _this.innerElement = document.createElement('div');
        _this.classListAdd(_this.innerElement, _styles2.default.inner);
        _this.element.appendChild(_this.innerElement);

        _this.seekbarPadding = document.createElement('div');
        _this.classListAdd(_this.seekbarPadding, _styles2.default.padding);
        _this.innerElement.appendChild(_this.seekbarPadding);

        _this.seekbarDuration = document.createElement('div');
        _this.classListAdd(_this.seekbarDuration, _styles2.default.seekbar, _styles2.default.duration);
        _this.innerElement.appendChild(_this.seekbarDuration);

        _this.seekbarBuffered = document.createElement('div');
        _this.classListAdd(_this.seekbarBuffered, _styles2.default.seekbar, _styles2.default.buffered);
        _this.innerElement.appendChild(_this.seekbarBuffered);
        _this.seekbarBuffered.style.transform = 'scaleX(0)';

        _this.seekbarFill = document.createElement('div');
        _this.classListAdd(_this.seekbarFill, _styles2.default.seekbar, _styles2.default.fill);
        _this.innerElement.appendChild(_this.seekbarFill);
        _this.seekbarFill.style.transform = 'scaleX(0)';

        _this.seekbarHighlight = document.createElement('div');
        _this.classListAdd(_this.seekbarHighlight, _styles2.default.seekbar, _styles2.default.highlight);
        _this.innerElement.appendChild(_this.seekbarHighlight);
        _this.seekbarHighlight.style.transform = 'scaleX(0)';

        _this.seekbarFigure = document.createElement('div');
        _this.classListAdd(_this.seekbarFigure, _styles2.default.seekDot);
        _this.seekbarDuration.appendChild(_this.seekbarFigure);
        _this.seekbarFigure.style.left = '0%';

        _this.preview = new _SeekbarPreview2.default(meister);
        _this.seekbarDuration.appendChild(_this.preview.getNode());

        _this.on('itemTimeInfo', function (timeInfo) {
            return _this.onItemTimeInfo(timeInfo);
        });
        _this.on('playerTimeUpdate', function (e) {
            return _this.onTimeUpdate(e);
        });
        _this.on('playerSeek', function (e) {
            return _this.onPlayerSeek(e);
        });
        _this.on('playerProgress', function (e) {
            return _this.onPlayerProgress(e);
        });
        _this.on('playerLoadedMetadata', function () {
            _this.loadedMetadata = true;
        });

        // Ad events.
        _this.points = {};
        _this.on('adCuePoints', function (info) {
            return _this.onAdCuePoints(info);
        });
        _this.on('adEnded', function (info) {
            return _this.onAdEnded(info);
        });

        // Mouse hover events.
        _this.element.addEventListener('mouseover', function (e) {
            return _this.onMouseOver(e);
        });
        _this.element.addEventListener('mousemove', function (e) {
            return _this.onMouseMove(e);
        });
        _this.element.addEventListener('mouseout', function () {
            return _this.onMouseOut();
        });

        // Seeking event listeners.
        _this.element.addEventListener('mousedown', function (e) {
            return _this.onSeekDown(e);
        });
        _this.element.addEventListener('touchstart', function (e) {
            return _this.onSeekDown(e);
        });

        _this.onSeekMove = function (e) {
            // Prevent the page from moving while scrubbing
            e.preventDefault();

            // Get the location in the page, hacky for touch events...
            var normalizedProgress = _this.normalizeEventPosition(e);

            if (_this.isDragging) {
                updateBar(_this.seekbarFill, normalizedProgress);
                updateBar(_this.seekbarHighlight, normalizedProgress);
                _this.updateFigure(normalizedProgress);
                _this.preview.update(normalizedProgress);
                _this.updateCurrentTime(normalizedProgress);
            }
        };

        _this.onSeekUp = function (e) {
            // Do nothing when a second touch ends.
            if (window.TouchEvent && e instanceof window.TouchEvent && e.touches.length > 0) {
                return;
            }

            if (_this.isDragging) {
                // Resume video
                if (_this.wasPlaying) _this.meister.play();

                _this.isDragging = false;

                // Always hide the preview on mobile.
                if (window.TouchEvent && e instanceof window.TouchEvent) {
                    _this.preview.hide();
                } else if (e.target !== _this.seekbarPadding) {
                    _this.preview.hide();
                }

                document.removeEventListener('mousemove', _this.onSeekMove);
                document.removeEventListener('mouseup', _this.onSeekUp);

                document.removeEventListener('touchmove', _this.onSeekMove);
                document.removeEventListener('touchend', _this.onSeekUp);
            }
        };
        return _this;
    }

    _createClass(Seekbar, [{
        key: 'onItemUnloaded',
        value: function onItemUnloaded() {
            var _this2 = this;

            this.loadedMetadata = false;

            this.seekbarBuffered.style.transform = 'scaleX(0)';
            this.seekbarHighlight.style.transform = 'scaleX(0)';
            this.seekbarFill.style.transform = 'scaleX(0)';
            this.seekbarFigure.style.left = '0%';

            Object.keys(this.points).forEach(function (adID) {
                if (_this2.points[adID] !== null) {
                    _this2.points[adID].remove();
                }
            });

            this.points = {};
            this.classListAdd(this.element, 'pf-ui-element-hidden');
        }
    }, {
        key: 'onItemTimeInfo',
        value: function onItemTimeInfo(timeInfo) {
            if (timeInfo.isLive && !timeInfo.hasDVR) {
                this.classListAdd(this.element, 'pf-ui-element-hidden');
            } else {
                this.classListRemove(this.element, 'pf-ui-element-hidden');
            }
        }
    }, {
        key: 'onTimeUpdate',
        value: function onTimeUpdate(e) {
            var normalizedProgress = e.currentTime / e.duration;

            updateBar(this.seekbarFill, normalizedProgress);
            this.updateFigure(normalizedProgress);
        }
    }, {
        key: 'onPlayerProgress',
        value: function onPlayerProgress(e) {
            if (!e) return;

            var timeRanges = e.buffered;
            var currentTimeRangeIndex = this.findTimerange(timeRanges);

            // Should we not get an index don't bother updating.
            if (currentTimeRangeIndex === -1) {
                return;
            }

            var duration = this.meister.duration;
            var targetTime = timeRanges.end(currentTimeRangeIndex);

            if (this.playOffset) {
                targetTime -= this.playOffset;
                duration -= this.playOffset;
            }

            var normalizedProgress = targetTime / duration;
            updateBar(this.seekbarBuffered, normalizedProgress);
        }

        // Mouse hover events.

    }, {
        key: 'onMouseOver',
        value: function onMouseOver(e) {
            if (window.TouchEvent && e instanceof window.TouchEvent) {
                this.pagedownX = e.touches[0].pageX;
                var rect = this.seekbarPadding.getBoundingClientRect();
                this.mousedownX = this.pagedownX - rect.left;
            } else {
                this.mousedownX = e.offsetX;
                this.pagedownX = e.pageX;
            }

            this.preview.show();
        }
    }, {
        key: 'onMouseMove',
        value: function onMouseMove(e) {
            var normalizedProgress = this.normalizeEventPosition(e);

            updateBar(this.seekbarHighlight, normalizedProgress);
            this.preview.update(normalizedProgress);
        }
    }, {
        key: 'onMouseOut',
        value: function onMouseOut() {
            // Reset the highlight bar.
            updateBar(this.seekbarHighlight, 0);

            if (!this.isDragging) {
                this.preview.hide();
            }
        }

        // Seeking event handles.

    }, {
        key: 'onSeekDown',
        value: function onSeekDown(e) {
            // Prevents user from selecting the page.
            e.preventDefault();

            // Get the preview to show and update.
            this.onMouseOver(e);
            this.onMouseMove(e);

            // Pause video
            this.wasPlaying = this.meister.playing;
            this.meister.pause();

            this.isDragging = true;

            // Get the location in the page, hacky for touch events...
            var normalizedProgress = this.normalizeEventPosition(e);

            updateBar(this.seekbarFill, normalizedProgress);
            this.updateFigure(normalizedProgress);
            this.updateCurrentTime(normalizedProgress);

            document.addEventListener('mousemove', this.onSeekMove);
            document.addEventListener('mouseup', this.onSeekUp);

            document.addEventListener('touchmove', this.onSeekMove);
            document.addEventListener('touchend', this.onSeekUp);
        }

        // Player seeked, update the seekbar.

    }, {
        key: 'onPlayerSeek',
        value: function onPlayerSeek(e) {
            var normalizedProgress = e.relativePosition;

            updateBar(this.seekbarFill, normalizedProgress);
            updateBar(this.seekbarHighlight, normalizedProgress);
            this.updateFigure(normalizedProgress);
        }

        // Ad event handles/

    }, {
        key: 'onAdCuePoints',
        value: function onAdCuePoints(info) {
            var _this3 = this;

            info.points.forEach(function (pointInfo) {
                return _this3.setPoint(pointInfo);
            });
        }
    }, {
        key: 'setPoint',
        value: function setPoint(time) {
            var self = this;

            function createPoint(t) {
                var elem = document.createElement('div');
                var normalizedProgress = t / self.meister.duration;

                self.meister.elementUtils.classListAdd(elem, 'pf-seek-bar-point', 'pf-ad-point');
                elem.id = 'adpoint-' + t;

                if (t < 0) {
                    normalizedProgress = 1;
                }

                var pointPosition = 100 * normalizedProgress;
                elem.style.left = pointPosition + '%';

                self.seekbarDuration.appendChild(elem);
                self.points['adpoint-' + t] = elem;
            }

            if (!this.loadedMetadata) {
                this.one('playerLoadedMetadata', function () {
                    createPoint(time);
                });
            } else {
                createPoint(time);
            }
        }
    }, {
        key: 'onAdEnded',
        value: function onAdEnded(info) {
            var adPodInfo = info.ad.getAdPodInfo();

            // Remove it on the end of the first ad in the break, because is simpler.
            var element = document.getElementById('adpoint-' + adPodInfo.getTimeOffset());
            delete this.points['adpoint-' + adPodInfo.getTimeOffset()];

            if (element !== null) {
                element.remove();
            }
        }

        // 'Private' methods.

    }, {
        key: 'normalizeEventPosition',
        value: function normalizeEventPosition(e) {
            var pageX = 0;
            if (window.TouchEvent && e instanceof window.TouchEvent) {
                pageX = e.touches[e.touches.length - 1].pageX;
            } else {
                pageX = e.pageX;
            }

            var position = pageX;
            position = this.mousedownX + (pageX - this.pagedownX);

            var normalizedProgress = position / this.seekbarPadding.offsetWidth;

            // Stay within the boundaries
            if (normalizedProgress > 1.0) {
                normalizedProgress = 1.0;
            } else if (normalizedProgress < 0) {
                normalizedProgress = 0;
            }

            return normalizedProgress;
        }
    }, {
        key: 'updateFigure',
        value: function updateFigure(percentage) {
            var figureLeftPercentage = 100 * percentage;
            this.seekbarFigure.style.left = figureLeftPercentage + '%';
        }
    }, {
        key: 'updateCurrentTime',
        value: function updateCurrentTime(percentage) {
            this.meister.trigger('requestSeek', {
                relativePosition: percentage
            });
        }
    }, {
        key: 'findTimerange',
        value: function findTimerange(timeRanges) {
            for (var i = 0; i < timeRanges.length; i += 1) {
                if (this.meister.currentTime >= timeRanges.start(i) && this.meister.currentTime <= timeRanges.end(i)) {
                    return i;
                }
            }

            // No range was found
            return -1;
        }
    }]);

    return Seekbar;
}(_BaseElement3.default);

exports.default = Seekbar;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseElement2 = __webpack_require__(3);

var _BaseElement3 = _interopRequireDefault(_BaseElement2);

var _styles = __webpack_require__(64);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SeekbarPreview = function (_BaseElement) {
    _inherits(SeekbarPreview, _BaseElement);

    function SeekbarPreview(meister) {
        _classCallCheck(this, SeekbarPreview);

        // preview element
        var _this = _possibleConstructorReturn(this, (SeekbarPreview.__proto__ || Object.getPrototypeOf(SeekbarPreview)).call(this, meister));

        _this.element = document.createElement('div');
        _this.classListAdd(_this.element, _styles2.default.container, _styles2.default.isHidden);

        // seekbar preview image
        _this.seekbarPreviewImage = document.createElement('img');
        _this.classListAdd(_this.seekbarPreviewImage, 'pf-seek-bar-preview-image');
        _this.element.appendChild(_this.seekbarPreviewImage);

        // seekbar preview time
        _this.seekbarPreviewTime = document.createElement('span');
        _this.seekbarPreviewTime.textContent = '0:00';
        _this.classListAdd(_this.seekbarPreviewTime, _styles2.default.previewTime);
        _this.element.appendChild(_this.seekbarPreviewTime);

        _this.images = [];

        _this.on('itemTimeInfo', function (timeInfo) {
            return _this.onItemTimeInfo(timeInfo);
        });

        _this.on('itemImagestream', function (info) {
            _this.images = info.images;
            _this.classListRemove(_this.element, 'no-preview');
        });
        return _this;
    }

    _createClass(SeekbarPreview, [{
        key: 'onItemUnloaded',
        value: function onItemUnloaded() {
            this.isLive = false;
            this.modifiedDuration = null;
            // Reset filmstrip
            this.images = [];
            this.classListAdd(this.element, 'no-preview');
        }
    }, {
        key: 'onItemTimeInfo',
        value: function onItemTimeInfo(timeInfo) {
            // Special case for DASH dvr
            if (timeInfo.isLive) {
                this.isLive = true;
                this.modifiedDuration = timeInfo.duration;
            }
        }
    }, {
        key: 'show',
        value: function show() {
            this.classListRemove(this.element, _styles2.default.isHidden);
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.classListAdd(this.element, _styles2.default.isHidden);
        }
    }, {
        key: 'update',
        value: function update(percentage) {
            var offsetWidth = this.element.offsetWidth;
            var offsetParentWidth = this.element.offsetParent.offsetWidth;
            var rightBoundary = offsetParentWidth - offsetWidth;

            // Calculate how much the preview needs to move to the right.
            var pixelsRight = offsetParentWidth * percentage - offsetWidth / 2;

            // Make it stay within the player.
            if (pixelsRight < 0) {
                pixelsRight = 0;
            } else if (pixelsRight > rightBoundary) {
                pixelsRight = rightBoundary;
            }

            this.element.style.transform = 'translate(' + pixelsRight + 'px)';

            var time = (this.modifiedDuration || this.meister.duration) * percentage;
            var image = this.getImageByTime(time);

            if (image) {
                this.seekbarPreviewImage.src = image;
            }

            if (this.modifiedDuration) {
                time = this.modifiedDuration - time;
                var timeString = this.meister.utils.timeToHMS(Math.round(time));
                this.seekbarPreviewTime.textContent = '-' + timeString;
            } else {
                this.seekbarPreviewTime.textContent = this.meister.utils.timeToHMS(Math.round(time));
            }
        }

        /**
         * Find the image src for a particular timestamp. Defaults to the last
         * image if no matching image is found.
         * @param {Number} time
         * @returns {String}
         */

    }, {
        key: 'getImageByTime',
        value: function getImageByTime(time) {
            if (this.images.length === 0) {
                return '';
            }

            var imageForTime = this.images.find(function (image) {
                return image.start <= time && image.end >= time;
            });

            if (imageForTime) {
                return imageForTime.src;
            }

            return this.images[this.images.length - 1].src;
        }
    }]);

    return SeekbarPreview;
}(_BaseElement3.default);

exports.default = SeekbarPreview;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseElement2 = __webpack_require__(3);

var _BaseElement3 = _interopRequireDefault(_BaseElement2);

var _styles = __webpack_require__(65);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Spinner = function (_BaseElement) {
    _inherits(Spinner, _BaseElement);

    function Spinner(meister) {
        _classCallCheck(this, Spinner);

        var _this = _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).call(this, meister));

        _this.meister = meister;

        _this.element = document.createElement('div');
        _this.classListAdd(_this.element, _styles2.default.container);

        _this.spinner = document.createElement('div');
        _this.classListAdd(_this.spinner, _styles2.default.spinner);
        _this.element.appendChild(_this.spinner);

        _this.spinnerMessage = document.createElement('div');
        _this.classListAdd(_this.spinnerMessage, _styles2.default.message);
        _this.element.appendChild(_this.spinnerMessage);

        // Register events.
        _this.on('playerBufferedEnough', function () {
            return _this.hideSpinner(true);
        });
        _this.on('playerPause', function () {
            return _this.hideSpinner();
        });
        _this.on('itemUnloaded', function () {
            return _this.hideSpinner();
        });
        _this.on('playerPlay', function () {
            return _this.hideSpinner();
        });
        _this.on('showLoading', function (e) {
            return _this.showSpinner(e);
        });
        _this.on('hideLoading', function () {
            return _this.hideSpinner();
        });
        return _this;
    }

    _createClass(Spinner, [{
        key: 'showSpinner',
        value: function showSpinner(e) {
            this.classListRemove(this.element, _styles2.default.hidden);
            this.classListRemove(this.spinner, _styles2.default.hidden);

            if (e && e.message) {
                this.spinnerMessage.innerHTML = e.message;
                this.classListRemove(this.spinnerMessage, _styles2.default.hidden);
            } else if (e && e.code) {
                this.spinnerMessage.innerHTML = this.meister.Localization.get(e.code);
                this.classListRemove(this.spinnerMessage, _styles2.default.hidden);
            }
        }
    }, {
        key: 'hideSpinner',
        value: function hideSpinner(fromBuffering) {
            // HACK quick fix so other hides don't hide buffering indicator
            if (this.spinnerMessage.innerHTML === 'Buffering...' && !fromBuffering) {
                return;
            }

            this.classListAdd(this.element, _styles2.default.hidden);
            this.classListAdd(this.spinner, _styles2.default.hidden);
            this.classListAdd(this.spinnerMessage, _styles2.default.hidden);
        }
    }]);

    return Spinner;
}(_BaseElement3.default);

exports.default = Spinner;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseElement2 = __webpack_require__(3);

var _BaseElement3 = _interopRequireDefault(_BaseElement2);

var _styles = __webpack_require__(66);

var _styles2 = _interopRequireDefault(_styles);

var _stepback = __webpack_require__(43);

var _stepback2 = _interopRequireDefault(_stepback);

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StepBackButton = function (_BaseElement) {
    _inherits(StepBackButton, _BaseElement);

    function StepBackButton(meister, config) {
        _classCallCheck(this, StepBackButton);

        var _this = _possibleConstructorReturn(this, (StepBackButton.__proto__ || Object.getPrototypeOf(StepBackButton)).call(this, meister));

        _this.config = config;
        _this.isLive = false;

        _this.element = document.createElement('div');
        _this.classListAdd(_this.element, _globalStyles2.default.uiElement, _globalStyles2.default.uiElementActive);

        // Default
        _this.classListAdd(_this.element, _styles2.default.button);
        _this.classListAdd(_this.element, _styles2.default.backwardButton);
        var Icon = (0, _stepback2.default)(_this.config.stepBack);
        _this.element.innerHTML = Icon;

        // Register event listeners
        _this.element.addEventListener('click', function () {
            return _this.onClick();
        });

        _this.on('itemTimeInfo', function (timeInfo) {
            return _this.onItemTimeInfo(timeInfo);
        });
        return _this;
    }

    _createClass(StepBackButton, [{
        key: 'onItemTimeInfo',
        value: function onItemTimeInfo(timeInfo) {
            this.isLive = timeInfo.isLive;

            if (this.isLive && this.config.disablePauseWithLive) {
                // hide on live
                this.classListAdd(this.element, 'pf-ui-element-hidden');
            }
        }
    }, {
        key: 'onClick',
        value: function onClick() {
            this.meister.trigger('requestSeek', {
                timeOffset: -1 * this.config.stepBack
            });
        }
    }]);

    return StepBackButton;
}(_BaseElement3.default);

exports.default = StepBackButton;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseElement2 = __webpack_require__(3);

var _BaseElement3 = _interopRequireDefault(_BaseElement2);

var _styles = __webpack_require__(67);

var _styles2 = _interopRequireDefault(_styles);

var _stepforward = __webpack_require__(44);

var _stepforward2 = _interopRequireDefault(_stepforward);

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StepForwardButton = function (_BaseElement) {
    _inherits(StepForwardButton, _BaseElement);

    function StepForwardButton(meister, config) {
        _classCallCheck(this, StepForwardButton);

        var _this = _possibleConstructorReturn(this, (StepForwardButton.__proto__ || Object.getPrototypeOf(StepForwardButton)).call(this, meister));

        _this.config = config;
        _this.isLive = false;

        _this.element = document.createElement('div');
        _this.classListAdd(_this.element, _globalStyles2.default.uiElement, _globalStyles2.default.uiElementActive);

        // Default
        _this.classListAdd(_this.element, _styles2.default.button);
        _this.classListAdd(_this.element, _styles2.default.forwardButton);
        var Icon = (0, _stepforward2.default)(_this.config.stepForward);
        _this.element.innerHTML = Icon;

        // Register event listeners
        _this.element.addEventListener('click', function () {
            return _this.onClick();
        });

        _this.on('itemTimeInfo', function (timeInfo) {
            return _this.onItemTimeInfo(timeInfo);
        });
        return _this;
    }

    _createClass(StepForwardButton, [{
        key: 'onItemTimeInfo',
        value: function onItemTimeInfo(timeInfo) {
            this.isLive = timeInfo.isLive;

            if (this.isLive && this.config.disablePauseWithLive) {
                // hide on live
                this.classListAdd(this.element, 'pf-ui-element-hidden');
            }
        }
    }, {
        key: 'onClick',
        value: function onClick() {
            this.meister.trigger('requestSeek', {
                timeOffset: this.config.stepForward
            });
        }
    }]);

    return StepForwardButton;
}(_BaseElement3.default);

exports.default = StepForwardButton;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseElement2 = __webpack_require__(3);

var _BaseElement3 = _interopRequireDefault(_BaseElement2);

var _styles = __webpack_require__(68);

var _styles2 = _interopRequireDefault(_styles);

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LIVE_THRESHOLD = 35;

var TimeDisplay = function (_BaseElement) {
    _inherits(TimeDisplay, _BaseElement);

    function TimeDisplay(meister) {
        _classCallCheck(this, TimeDisplay);

        var _this = _possibleConstructorReturn(this, (TimeDisplay.__proto__ || Object.getPrototypeOf(TimeDisplay)).call(this, meister));

        _this.element = document.createElement('div');
        _this.classListAdd(_this.element, _globalStyles2.default.uiElement, _styles2.default.container);
        // HACK: dirty microsoft
        if (_this.meister.browser.isIE || _this.meister.browser.isEdge) {
            _this.classListAdd(_this.element, 'microsoft-hack');
        }

        _this.currentTime = document.createElement('span');
        _this.currentTime.innerHTML = '0:00';
        _this.classListAdd(_this.currentTime, _styles2.default.currentTime);

        _this.seperator = document.createElement('span');
        _this.seperator.innerHTML = '/';
        _this.classListAdd(_this.seperator, _styles2.default.seperator);

        _this.duration = document.createElement('span');
        _this.duration.innerHTML = '0:00';
        _this.classListAdd(_this.duration, _styles2.default.duration);
        _this.duration.addEventListener('click', function () {
            return _this.meister.trigger('requestGoLive');
        });

        _this.element.appendChild(_this.currentTime);
        _this.element.appendChild(_this.seperator);
        _this.element.appendChild(_this.duration);

        _this.isLive = false;

        _this.on('itemTimeInfo', function (timeInfo) {
            return _this.onItemTimeInfo(timeInfo);
        });
        _this.on('playerTimeUpdate', function (e) {
            return _this.onTimeUpdate(e);
        });
        _this.on('playerSeek', function (e) {
            return _this.onPlayerSeek(e);
        });

        // Ad variables.
        _this.adTimer = null;
        _this.adDuration = 0;
        return _this;
    }

    _createClass(TimeDisplay, [{
        key: 'onItemUnloaded',
        value: function onItemUnloaded() {
            this.isLive = false;
            this.classListRemove(this.duration, 'go-live', _globalStyles2.default.uiElementActive);

            this.currentTime.innerHTML = '-';
            this.duration.innerHTML = '-';
        }
    }, {
        key: 'onItemTimeInfo',
        value: function onItemTimeInfo(timeInfo) {
            if (timeInfo.isLive) {
                this.isLive = true;
                this.duration.innerHTML = 'LIVE';

                if (!timeInfo.hasDVR) this.currentTime.innerHTML = '-';
            } else {
                this.duration.innerHTML = this.createTimeString(timeInfo.duration);
            }
        }
    }, {
        key: 'onTimeUpdate',
        value: function onTimeUpdate(e) {
            // Set the duration and current time for VODs
            if (!this.isLive) {
                this.currentTime.innerHTML = this.createTimeString(e.currentTime);
                this.duration.innerHTML = this.createTimeString(e.duration);
                return;
            }

            // If a livestream is close enough to the edge display no time.
            var behindLive = e.duration - e.currentTime;

            if (behindLive < LIVE_THRESHOLD) {
                this.currentTime.innerHTML = '-';
                this.classListRemove(this.duration, 'go-live', _globalStyles2.default.uiElementActive);
            }
        }
    }, {
        key: 'onPlayerSeek',
        value: function onPlayerSeek(e) {
            // Set the duration and current time for VODs
            if (!this.isLive) {
                this.currentTime.innerHTML = this.createTimeString(e.currentTime);
                this.duration.innerHTML = this.createTimeString(e.duration);
                return;
            }

            var behindLive = e.duration - e.currentTime;
            if (behindLive < LIVE_THRESHOLD) {
                this.currentTime.innerHTML = '-';
                this.classListRemove(this.duration, 'go-live', _globalStyles2.default.uiElementActive);
                return;
            }

            // Display the amount of time the player is behind live.
            var timeString = this.createTimeString(behindLive);
            this.currentTime.innerHTML = '-' + timeString;

            // Activate the go live button.
            this.classListAdd(this.duration, 'go-live', _globalStyles2.default.uiElementActive);
        }
    }, {
        key: 'createTimeString',
        value: function createTimeString(time) {
            var roundTime = Math.round(time);
            if (roundTime < 0) {
                roundTime = 0;
            }

            return this.meister.utils.timeToHMS(roundTime);
        }
    }]);

    return TimeDisplay;
}(_BaseElement3.default);

exports.default = TimeDisplay;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseElement2 = __webpack_require__(3);

var _BaseElement3 = _interopRequireDefault(_BaseElement2);

var _styles = __webpack_require__(69);

var _styles2 = _interopRequireDefault(_styles);

var _volume = __webpack_require__(45);

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var volumeIconMute = (0, _volume.volumeMuteIcon)();
var volumeIconLow = (0, _volume.volumeLowIcon)();
var volumeIconMedium = (0, _volume.volumeMediumIcon)();
var volumeIconHigh = (0, _volume.volumeHighIcon)();

var VolumeSlider = function (_BaseElement) {
    _inherits(VolumeSlider, _BaseElement);

    function VolumeSlider(meister) {
        _classCallCheck(this, VolumeSlider);

        var _this = _possibleConstructorReturn(this, (VolumeSlider.__proto__ || Object.getPrototypeOf(VolumeSlider)).call(this, meister));

        _this.element = document.createElement('div');

        // Can't control volume on iOS when it's not playing inline
        if (_this.meister.browser.isiOS && !_this.meister.config.iosPlaysInline) {
            _this.classListAdd(_this.element, _globalStyles2.default.uiElementHidden);
            return _possibleConstructorReturn(_this);
        }

        _this.isDragging = false;
        _this.mousedownY = 0;
        _this.pagedownY = 0;

        _this.classListAdd(_this.element, _globalStyles2.default.uiElement, _styles2.default.volume);
        _this.classListAdd(_this.element, _globalStyles2.default.uiElementActive);

        _this.volumeButton = document.createElement('div');
        _this.classListAdd(_this.volumeButton, _styles2.default.volumeButton);
        _this.classListAdd(_this.volumeButton, _globalStyles2.default.svg, _styles2.default.volumeMute);
        _this.volumeButton.innerHTML = volumeIconMute;
        _this.element.appendChild(_this.volumeButton);

        _this.sliderContainer = document.createElement('div');

        if (_this.meister.browser.isiOS) {
            _this.classListAdd(_this.sliderContainer, _styles2.default.container, _styles2.default.isClosed, _globalStyles2.default.uiElementHidden);
        } else {
            _this.classListAdd(_this.sliderContainer, _styles2.default.container, _styles2.default.isClosed);
        }

        _this.element.appendChild(_this.sliderContainer);

        _this.sliderInner = document.createElement('div');
        _this.classListAdd(_this.sliderInner, _styles2.default.inner);
        _this.sliderContainer.appendChild(_this.sliderInner);

        _this.volumeBar = document.createElement('div');
        _this.classListAdd(_this.volumeBar, _styles2.default.volumeBar);
        _this.sliderInner.appendChild(_this.volumeBar);

        _this.volumeBarFill = document.createElement('div');
        _this.classListAdd(_this.volumeBarFill, _styles2.default.volumeBarFill);
        _this.volumeBar.appendChild(_this.volumeBarFill);

        _this.volumeBarFigure = document.createElement('div');
        _this.classListAdd(_this.volumeBarFigure, _styles2.default.volumeBarFigure);
        _this.volumeBar.appendChild(_this.volumeBarFigure);

        // Add volume event listeners.
        _this.on('playerVolumeChange', function () {
            return _this.onVolumeChange();
        });
        _this.on('playerLoadedMetadata', function () {
            return _this.onVolumeChange();
        });

        // Add mouse event listeners
        if (!_this.meister.browser.isMobile) {
            // Touch devices mute on click, which is not desireable
            _this.volumeButton.addEventListener('click', function () {
                return _this.onClick();
            });
        }

        _this.element.addEventListener('mouseover', function () {
            return _this.showSlider(true);
        });
        _this.element.addEventListener('mouseleave', function () {
            return _this.showSlider(false);
        });

        _this.sliderInner.addEventListener('mousedown', function (e) {
            return _this.onDown(e);
        });
        _this.sliderInner.addEventListener('touchstart', function (e) {
            return _this.onDown(e);
        });

        _this.onMove = function (e) {
            if (_this.isDragging) {
                _this.updateBar(e);
            }
        };

        _this.onUp = function (e) {
            if (_this.isDragging) {
                _this.isDragging = false;

                _this.showSlider(false);

                document.removeEventListener('mousemove', _this.onMove);
                document.removeEventListener('mouseup', _this.onUp);

                document.addEventListener('touchmove', _this.onMove);
                document.addEventListener('touchend', _this.onUp);
            }
        };
        return _this;
    }

    _createClass(VolumeSlider, [{
        key: 'onDown',
        value: function onDown(e) {
            // Prevents user from selecting the page.
            e.preventDefault();

            this.isDragging = true;

            if (window.TouchEvent && e instanceof window.TouchEvent) {
                this.pagedownY = e.touches[0].pageY;
                var rect = e.target.getBoundingClientRect();
                this.mousedownY = this.pagedownY - rect.top;
            } else {
                this.mousedownY = e.offsetY;
                this.pagedownY = e.pageY;
            }

            this.updateBar(e);

            document.addEventListener('mousemove', this.onMove);
            document.addEventListener('mouseup', this.onUp);

            document.addEventListener('touchmove', this.onMove);
            document.addEventListener('touchend', this.onUp);
        }
    }, {
        key: 'showSlider',
        value: function showSlider(on) {
            if (this.isDragging) {
                return;
            }
            if (on) {
                this.classListAdd(this.sliderContainer, _styles2.default.isOpen);
                this.classListRemove(this.sliderContainer, _styles2.default.isClosed);
            } else {
                this.classListRemove(this.sliderContainer, _styles2.default.isOpen);
                this.classListAdd(this.sliderContainer, _styles2.default.isClosed);
            }
        }
    }, {
        key: 'onClick',
        value: function onClick() {
            this.meister.muted = !this.meister.muted;
            this.meister.trigger('playerVolumeChange');
        }
    }, {
        key: 'onVolumeChange',
        value: function onVolumeChange() {
            var normalizedProgress = this.meister.volume;

            if (this.meister.muted) {
                normalizedProgress = 0;
            }

            this.volumeBarFill.style.transform = 'scaleY(' + normalizedProgress + ')';
            var bottomPercentage = 100 * normalizedProgress;
            this.volumeBarFigure.style.bottom = bottomPercentage + '%';

            this.updateIcon();
        }
    }, {
        key: 'updateBar',
        value: function updateBar(e) {
            // Stop muting when the user changes the volume.
            this.meister.muted = false;

            var volume = this.normalizeEventPosition(e);

            if (volume > 1) {
                volume = 1;
            } else if (volume < 0) {
                volume = 0;
            }

            this.meister.volume = volume;
        }
    }, {
        key: 'updateIcon',
        value: function updateIcon() {
            var volume = this.meister.volume;
            var iconClass = _styles2.default.volumeMute;
            var iconSVG = volumeIconMute;

            if (this.meister.muted) {
                iconClass = _styles2.default.volumeMute;
                iconSVG = volumeIconMute;
            } else if (volume <= 0.33 && volume >= 0.01) {
                iconClass = _styles2.default.volumeLow;
                iconSVG = volumeIconLow;
            } else if (volume >= 0.33 && volume <= 0.66) {
                iconClass = _styles2.default.volumeMedium;
                iconSVG = volumeIconMedium;
            } else if (volume >= 0.66 && volume <= 1) {
                iconClass = _styles2.default.volumeHigh;
                iconSVG = volumeIconHigh;
            }

            this.classListRemove(this.volumeButton, _styles2.default.volumeMute, _styles2.default.volumeLow, _styles2.default.volumeMedium, _styles2.default.volumeHigh);
            this.classListAdd(this.volumeButton, iconClass);
            this.volumeButton.innerHTML = iconSVG;
        }
    }, {
        key: 'normalizeEventPosition',
        value: function normalizeEventPosition(e) {
            var pageY = 0;
            if (window.TouchEvent && e instanceof window.TouchEvent) {
                pageY = e.touches[e.touches.length - 1].pageY;
            } else {
                pageY = e.pageY;
            }

            var volumeBarFigureHeight = this.volumeBarFigure.offsetHeight;
            var position = this.mousedownY + (pageY - this.pagedownY - volumeBarFigureHeight);

            var progressCalculation = 1 - position / this.volumeBar.offsetHeight;
            var normalizedProgress = Math.max(Math.min(progressCalculation, 1), 0);

            return normalizedProgress;
        }
    }]);

    return VolumeSlider;
}(_BaseElement3.default);

exports.default = VolumeSlider;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createStandardElement;

var _CaptionsButton = __webpack_require__(21);

var _CaptionsButton2 = _interopRequireDefault(_CaptionsButton);

var _FullscreenButton = __webpack_require__(22);

var _FullscreenButton2 = _interopRequireDefault(_FullscreenButton);

var _PlayButton = __webpack_require__(23);

var _PlayButton2 = _interopRequireDefault(_PlayButton);

var _PlaylistButtons = __webpack_require__(24);

var _QualityButton = __webpack_require__(26);

var _QualityButton2 = _interopRequireDefault(_QualityButton);

var _Seekbar = __webpack_require__(28);

var _Seekbar2 = _interopRequireDefault(_Seekbar);

var _Spinner = __webpack_require__(30);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _StepBackButton = __webpack_require__(31);

var _StepBackButton2 = _interopRequireDefault(_StepBackButton);

var _StepForwardButton = __webpack_require__(32);

var _StepForwardButton2 = _interopRequireDefault(_StepForwardButton);

var _TimeDisplay = __webpack_require__(33);

var _TimeDisplay2 = _interopRequireDefault(_TimeDisplay);

var _VolumeSlider = __webpack_require__(34);

var _VolumeSlider2 = _interopRequireDefault(_VolumeSlider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createStandardElement(meister, config, name) {
    switch (name) {
        case 'captionsbutton':
            return new _CaptionsButton2.default(meister, config);
        case 'fullscreenbutton':
            return new _FullscreenButton2.default(meister, config);
        case 'playbutton':
            return new _PlayButton2.default(meister, config);
        case 'playlistpreviousbutton':
            return new _PlaylistButtons.PlaylistPreviousButton(meister, config);
        case 'playlistnextbutton':
            return new _PlaylistButtons.PlaylistNextButton(meister, config);
        case 'qualitybutton':
            return new _QualityButton2.default(meister, config);
        case 'seekbar':
            return new _Seekbar2.default(meister, config);
        case 'spinner':
            return new _Spinner2.default(meister, config);
        case 'stepbackbutton':
            return new _StepBackButton2.default(meister, config);
        case 'stepforwardbutton':
            return new _StepForwardButton2.default(meister, config);
        case 'timedisplay':
            return new _TimeDisplay2.default(meister, config);
        case 'volumeslider':
            return new _VolumeSlider2.default(meister, config);
        default:
            return null;
    }
}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

var _createClassNameString = __webpack_require__(4);

var _createClassNameString2 = _interopRequireDefault(_createClassNameString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fullscreenIcon = function fullscreenIcon(cssClass) {
    return '\n<svg class="' + (0, _createClassNameString2.default)(_globalStyles2.default.svg, cssClass) + '" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">\n    <path fill="currentColor" d="M14.990778,4 L19.009222,4 C19.2777897,4 19.5243695,4.11070974 19.7117708,4.2928267 C19.8904143,4.4719102 20,4.71851976 20,4.99077797 L20,9.00922203 C20,9.54902482 19.5527519,10 19.0010434,10 L17.9989566,10 C17.4426603,10 17,9.55641359 17,9.00922203 L17,7 L14.990778,7 C14.4509752,7 14,6.55275191 14,6.00104344 L14,4.99895656 C14,4.44266033 14.4435864,4 14.990778,4 Z M14.990778,20 C14.4435864,20 14,19.5573397 14,19.0010434 L14,17.9989566 C14,17.4472481 14.4509752,17 14.990778,17 L17,17 L17,14.990778 C17,14.4435864 17.4426603,14 17.9989566,14 L19.0010434,14 C19.5527519,14 20,14.4509752 20,14.990778 L20,19.009222 C20,19.2814802 19.8904143,19.5280898 19.7117708,19.7071733 C19.5243695,19.8892903 19.2777897,20 19.009222,20 L14.990778,20 Z M9.00922203,4 C9.55641359,4 10,4.44266033 10,4.99895656 L10,6.00104344 C10,6.55275191 9.54902482,7 9.00922203,7 L7,7 L7,9.00922203 C7,9.55641359 6.55733967,10 6.00104344,10 L4.99895656,10 C4.44724809,10 4,9.54902482 4,9.00922203 L4,4.99077797 C4,4.71851976 4.10958568,4.4719102 4.28822924,4.2928267 C4.47563053,4.11070974 4.72221026,4 4.99077797,4 L9.00922203,4 Z M9.00922203,20 L4.99077797,20 C4.72221026,20 4.47563053,19.8892903 4.28822924,19.7071733 C4.10958568,19.5280898 4,19.2814802 4,19.009222 L4,14.990778 C4,14.4509752 4.44724809,14 4.99895656,14 L6.00104344,14 C6.55733967,14 7,14.4435864 7,14.990778 L7,17 L9.00922203,17 C9.54902482,17 10,17.4472481 10,17.9989566 L10,19.0010434 C10,19.5573397 9.55641359,20 9.00922203,20 Z"></path>\n</svg>';
};

exports.default = fullscreenIcon;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

var _createClassNameString = __webpack_require__(4);

var _createClassNameString2 = _interopRequireDefault(_createClassNameString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fullscreenExitIcon = function fullscreenExitIcon(cssClass) {
    return '\n<svg class="' + (0, _createClassNameString2.default)(_globalStyles2.default.svg, cssClass) + '" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">\n    <path fill="currentColor" d="M19.009222,10 L14.990778,10 C14.7222103,10 14.4756305,9.88929026 14.2882292,9.7071733 C14.1095857,9.5280898 14,9.28148024 14,9.00922203 L14,4.99077797 C14,4.45097518 14.4472481,4 14.9989566,4 L16.0010434,4 C16.5573397,4 17,4.44358641 17,4.99077797 L17,7 L19.009222,7 C19.5490248,7 20,7.44724809 20,7.99895656 L20,9.00104344 C20,9.55733967 19.5564136,10 19.009222,10 Z M19.009222,14 C19.5564136,14 20,14.4426603 20,14.9989566 L20,16.0010434 C20,16.5527519 19.5490248,17 19.009222,17 L17,17 L17,19.009222 C17,19.5564136 16.5573397,20 16.0010434,20 L14.9989566,20 C14.4472481,20 14,19.5490248 14,19.009222 L14,14.990778 C14,14.7185198 14.1095857,14.4719102 14.2882292,14.2928267 C14.4756305,14.1107097 14.7222103,14 14.990778,14 L19.009222,14 Z M4.99077797,10 C4.44358641,10 4,9.55733967 4,9.00104344 L4,7.99895656 C4,7.44724809 4.45097518,7 4.99077797,7 L7,7 L7,4.99077797 C7,4.44358641 7.44266033,4 7.99895656,4 L9.00104344,4 C9.55275191,4 10,4.45097518 10,4.99077797 L10,9.00922203 C10,9.28148024 9.89041432,9.5280898 9.71177076,9.7071733 C9.52436947,9.88929026 9.27778974,10 9.00922203,10 L4.99077797,10 Z M4.99077797,14 L9.00922203,14 C9.27778974,14 9.52436947,14.1107097 9.71177076,14.2928267 C9.89041432,14.4719102 10,14.7185198 10,14.990778 L10,19.009222 C10,19.5490248 9.55275191,20 9.00104344,20 L7.99895656,20 C7.44266033,20 7,19.5564136 7,19.009222 L7,17 L4.99077797,17 C4.45097518,17 4,16.5527519 4,16.0010434 L4,14.9989566 C4,14.4426603 4.44358641,14 4.99077797,14 Z"></path>\n</svg>\n';
};

exports.default = fullscreenExitIcon;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

var _createClassNameString = __webpack_require__(4);

var _createClassNameString2 = _interopRequireDefault(_createClassNameString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nextIcon = function nextIcon(cssClass) {
    return '\n<svg class="' + (0, _createClassNameString2.default)(_globalStyles2.default.svg, cssClass) + '" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">\n    <path fill="currentColor" d="M15.5797546,11.3085619 C16.1433363,11.6897833 16.1368179,12.3122745 15.5797546,12.6890866 L5.02045486,19.8316732 C4.4568732,20.2128946 4,19.9252466 4,19.1843471 L4,4.81330147 C4,4.07457175 4.46339158,3.78916316 5.02045486,4.16597534 L15.5797546,11.3085619 Z M17,5.00087166 C17,4.4481055 17.4426603,4 17.9989566,4 L19.0010434,4 C19.5527519,4 20,4.44463086 20,5.00087166 L20,18.9991283 C20,19.5518945 19.5573397,20 19.0010434,20 L17.9989566,20 C17.4472481,20 17,19.5553691 17,18.9991283 L17,5.00087166 Z"></path>\n</svg>\n';
};

exports.default = nextIcon;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

var _createClassNameString = __webpack_require__(4);

var _createClassNameString2 = _interopRequireDefault(_createClassNameString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pauseIcon = function pauseIcon(cssClass) {
    return '\n<svg class="' + (0, _createClassNameString2.default)(_globalStyles2.default.svg, cssClass) + '" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n    <path fill="currentColor" d="M6,4.66712976 C6,4.29868417 6.44335318,4 7.0093689,4 L8.9906311,4 C9.54809015,4 10,4.29831281 10,4.66712976 L10,19.3328702 C10,19.7013158 9.55664682,20 8.9906311,20 L7.0093689,20 C6.45190985,20 6,19.7016872 6,19.3328702 L6,4.66712976 Z M14,4.66712976 C14,4.29868417 14.4433532,4 15.0093689,4 L16.9906311,4 C17.5480902,4 18,4.29831281 18,4.66712976 L18,19.3328702 C18,19.7013158 17.5566468,20 16.9906311,20 L15.0093689,20 C14.4519098,20 14,19.7016872 14,19.3328702 L14,4.66712976 Z" id="pause"></path>\n</svg>\n';
};

exports.default = pauseIcon;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

var _createClassNameString = __webpack_require__(4);

var _createClassNameString2 = _interopRequireDefault(_createClassNameString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var playIcon = function playIcon(cssClass) {
    return '\n<svg class="' + (0, _createClassNameString2.default)(_globalStyles2.default.svg, cssClass) + '" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n    <path fill="currentColor" d="M17.5797546,11.3085619 C18.1433363,11.6897833 18.1368179,12.3122745 17.5797546,12.6890866 L7.02045486,19.8316732 C6.4568732,20.2128946 6,19.9252466 6,19.1843471 L6,4.81330147 C6,4.07457175 6.46339158,3.78916316 7.02045486,4.16597534 L17.5797546,11.3085619 Z" id="play"></path>\n</svg>\n';
};

exports.default = playIcon;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

var _createClassNameString = __webpack_require__(4);

var _createClassNameString2 = _interopRequireDefault(_createClassNameString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prevIcon = function prevIcon(cssClass) {
    return '\n<svg class="' + (0, _createClassNameString2.default)(_globalStyles2.default.svg, cssClass) + '" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">\n    <path fill="currentColor" d="M8.42024541,11.3085619 C7.85666375,11.6897833 7.86318212,12.3122745 8.42024541,12.6890866 L18.9795451,19.8316732 C19.5431268,20.2128946 20,19.9252466 20,19.1843471 L20,4.81330147 C20,4.07457175 19.5366084,3.78916316 18.9795451,4.16597534 L8.42024541,11.3085619 Z M7,5.00087166 C7,4.4481055 6.55733967,4 6.00104344,4 L4.99895656,4 C4.44724809,4 4,4.44463086 4,5.00087166 L4,18.9991283 C4,19.5518945 4.44266033,20 4.99895656,20 L6.00104344,20 C6.55275191,20 7,19.5553691 7,18.9991283 L7,5.00087166 Z"></path>\n</svg>\n';
};

exports.default = prevIcon;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

var _createClassNameString = __webpack_require__(4);

var _createClassNameString2 = _interopRequireDefault(_createClassNameString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var qualityIcon = function qualityIcon(cssClass) {
    return '\n<svg class="' + (0, _createClassNameString2.default)(_globalStyles2.default.svg, cssClass) + '" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">\n    <path fill="currentColor" d="M0,5.99406028 C0,4.8927712 0.897026226,4 2.00494659,4 L21.9950534,4 C23.1023548,4 24,4.89451376 24,5.99406028 L24,18.0059397 C24,19.1072288 23.1029738,20 21.9950534,20 L2.00494659,20 C0.897645164,20 0,19.1054862 0,18.0059397 L0,5.99406028 Z M9,11 L6,11 L6,8 L4,8 L4,16 L6,16 L6,13 L9,13 L9,16 L11,16 L11,8 L9,8 L9,11 Z M16,16 C18.209139,16 20,14.209139 20,12 C20,9.790861 18.209139,8 16,8 L13,8 L13,16 L16,16 Z M15,14 L15,10 L16,10 C17.1045695,10 18,10.8954305 18,12 C18,13.1045695 17.1045695,14 16,14 L15,14 Z"></path>\n</svg>\n';
};

exports.default = qualityIcon;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

var _createClassNameString = __webpack_require__(4);

var _createClassNameString2 = _interopRequireDefault(_createClassNameString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stepBackIcon = function stepBackIcon(seconds) {
    return '\n<svg class="' + (0, _createClassNameString2.default)(_globalStyles2.default.svg) + '" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n     viewBox="0 0 110 161.2" style="enable-background:new 0 0 110 161.2;" xml:space="preserve">\n<style type="text/css">\n    .st0{fill:none;stroke:currentColor;stroke-width:10;stroke-linecap:round;stroke-miterlimit:10;}\n    .st1{font-size:60px;fill:currentColor}\n</style>\n<g>\n    <path class="st0" d="M6,88.8c0,27.1,21.9,49,49,49s49-21.9,49-49s-19.9-49-47-49H33.5"/>\n    <polyline class="st0" points="50,56 32.2,39.8 50,23.5     "/>\n    <polyline class="st0" points="29,56 11.2,39.8 29,23.5     "/>\n</g>\n<text transform="matrix(1 0 0 1 22.2207 108.75)" class="st1">' + seconds + '</text>\n</svg>\n';
};

exports.default = stepBackIcon;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

var _createClassNameString = __webpack_require__(4);

var _createClassNameString2 = _interopRequireDefault(_createClassNameString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stepForwardIcon = function stepForwardIcon(seconds) {
    return '\n<svg class="' + (0, _createClassNameString2.default)(_globalStyles2.default.svg) + '"  version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n        viewBox="0 0 110 161.2" style="enable-background:new 0 0 110 161.2;" xml:space="preserve">\n    <style type="text/css">\n        .st0{fill:none;stroke:currentColor;stroke-width:8;stroke-linecap:round;stroke-miterlimit:10;}\n        .st1{font-size:60px;fill:currentColor;}\n    </style>\n<g>\n    <path class="st0" d="M104,88.8c0,27.1-21.9,49-49,49s-49-21.9-49-49s19.9-49,47-49h23.5"/>\n    <polyline class="st0" points="60,56 77.8,39.8 60,23.5     "/>\n    <polyline class="st0" points="81,56 98.8,39.8 81,23.5     "/>\n</g>\n<text transform="matrix(1 0 0 1 53 108.75)" text-anchor="middle" class="st1">' + seconds + '</text>\n</svg>\n';
};

exports.default = stepForwardIcon;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.volumeHighIcon = exports.volumeMediumIcon = exports.volumeLowIcon = exports.volumeMuteIcon = undefined;

var _globalStyles = __webpack_require__(0);

var _globalStyles2 = _interopRequireDefault(_globalStyles);

var _createClassNameString = __webpack_require__(4);

var _createClassNameString2 = _interopRequireDefault(_createClassNameString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var volumeMuteIcon = exports.volumeMuteIcon = function volumeMuteIcon(cssClass) {
    return '\n<svg class="' + (0, _createClassNameString2.default)(_globalStyles2.default.svg, cssClass) + '" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">\n    <path fill="currentColor" d="M18,10.7529107 L15.5073637,8.2602744 C15.1664641,7.91937486 14.6031064,7.914358 14.2587322,8.25873219 C13.9119571,8.6055073 13.9150485,9.16213774 14.2602744,9.50736367 L16.7529107,12 L14.2602744,14.4926363 C13.9193749,14.8335359 13.914358,15.3968936 14.2587322,15.7412678 C14.6055073,16.0880429 15.1621377,16.0849515 15.5073637,15.7397256 L18,13.2470893 L20.4926363,15.7397256 C20.8335359,16.0806251 21.3968936,16.085642 21.7412678,15.7412678 C22.0880429,15.3944927 22.0849515,14.8378623 21.7397256,14.4926363 L19.2470893,12 L21.7397256,9.50736367 C22.0806251,9.16646413 22.085642,8.60310639 21.7412678,8.25873219 C21.3944927,7.91195709 20.8378623,7.91504847 20.4926363,8.2602744 L18,10.7529107 Z"></path>\n    <path fill="currentColor" d="M1.0093689,8.0749622 C0.451909848,8.0749622 0,8.51944308 0,9.06903369 L0,14.9298135 C0,15.478824 0.443353176,15.923885 1.0093689,15.923885 L4,15.923885 L9.37646484,19.6916936 C10.2772423,20.3229555 11,19.9530982 11,18.872049 L11,5.1267982 C11,4.0451514 10.2731186,3.67878158 9.37646484,4.30715352 L4,8.0749622 L1.0093689,8.0749622 Z"></path>\n</svg>\n';
};

var volumeLowIcon = exports.volumeLowIcon = function volumeLowIcon(cssClass) {
    return '\n<svg class="' + (0, _createClassNameString2.default)(_globalStyles2.default.svg, cssClass) + '" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">\n    <path fill="currentColor" d="M14.8284271,14.8284271 C16.3905243,13.26633 16.3905243,10.73367 14.8284271,9.17157288 C14.4379028,8.78104858 13.8047379,8.78104858 13.4142136,9.17157288 C13.0236893,9.56209717 13.0236893,10.1952621 13.4142136,10.5857864 C14.1952621,11.366835 14.1952621,12.633165 13.4142136,13.4142136 C13.0236893,13.8047379 13.0236893,14.4379028 13.4142136,14.8284271 C13.8047379,15.2189514 14.4379028,15.2189514 14.8284271,14.8284271 Z" fill-rule="nonzero"></path>\n    <path fill="currentColor" d="M1.0093689,8.0749622 C0.451909848,8.0749622 0,8.51944308 0,9.06903369 L0,14.9298135 C0,15.478824 0.443353176,15.923885 1.0093689,15.923885 L4,15.923885 L9.37646484,19.6916936 C10.2772423,20.3229555 11,19.9530982 11,18.872049 L11,5.1267982 C11,4.0451514 10.2731186,3.67878158 9.37646484,4.30715352 L4,8.0749622 L1.0093689,8.0749622 Z"></path>\n</svg>\n';
};

var volumeMediumIcon = exports.volumeMediumIcon = function volumeMediumIcon(cssClass) {
    return '\n<svg class="' + (0, _createClassNameString2.default)(_globalStyles2.default.svg, cssClass) + '" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">\n    <path fill="currentColor" d="M14.8284271,14.8284271 C16.3905243,13.26633 16.3905243,10.73367 14.8284271,9.17157288 C14.4379028,8.78104858 13.8047379,8.78104858 13.4142136,9.17157288 C13.0236893,9.56209717 13.0236893,10.1952621 13.4142136,10.5857864 C14.1952621,11.366835 14.1952621,12.633165 13.4142136,13.4142136 C13.0236893,13.8047379 13.0236893,14.4379028 13.4142136,14.8284271 C13.8047379,15.2189514 14.4379028,15.2189514 14.8284271,14.8284271 Z" fill-rule="nonzero"></path>\n    <path fill="currentColor" d="M17.6568542,17.6568542 C20.7810486,14.5326599 20.7810486,9.46734008 17.6568542,6.34314575 C17.26633,5.95262146 16.633165,5.95262146 16.2426407,6.34314575 C15.8521164,6.73367004 15.8521164,7.36683502 16.2426407,7.75735931 C18.5857864,10.1005051 18.5857864,13.8994949 16.2426407,16.2426407 C15.8521164,16.633165 15.8521164,17.26633 16.2426407,17.6568542 C16.633165,18.0473785 17.26633,18.0473785 17.6568542,17.6568542 Z" fill-rule="nonzero"></path>\n    <path fill="currentColor" d="M1.0093689,8.0749622 C0.451909848,8.0749622 0,8.51944308 0,9.06903369 L0,14.9298135 C0,15.478824 0.443353176,15.923885 1.0093689,15.923885 L4,15.923885 L9.37646484,19.6916936 C10.2772423,20.3229555 11,19.9530982 11,18.872049 L11,5.1267982 C11,4.0451514 10.2731186,3.67878158 9.37646484,4.30715352 L4,8.0749622 L1.0093689,8.0749622 Z"></path>\n</svg>\n';
};

var volumeHighIcon = exports.volumeHighIcon = function volumeHighIcon(cssClass) {
    return '\n<svg class="' + (0, _createClassNameString2.default)(_globalStyles2.default.svg, cssClass) + '" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">\n    <path fill="currentColor" d="M14.8284271,14.8284271 C16.3905243,13.26633 16.3905243,10.73367 14.8284271,9.17157288 C14.4379028,8.78104858 13.8047379,8.78104858 13.4142136,9.17157288 C13.0236893,9.56209717 13.0236893,10.1952621 13.4142136,10.5857864 C14.1952621,11.366835 14.1952621,12.633165 13.4142136,13.4142136 C13.0236893,13.8047379 13.0236893,14.4379028 13.4142136,14.8284271 C13.8047379,15.2189514 14.4379028,15.2189514 14.8284271,14.8284271 Z" fill-rule="nonzero"></path>\n    <path fill="currentColor" d="M17.6568542,17.6568542 C20.7810486,14.5326599 20.7810486,9.46734008 17.6568542,6.34314575 C17.26633,5.95262146 16.633165,5.95262146 16.2426407,6.34314575 C15.8521164,6.73367004 15.8521164,7.36683502 16.2426407,7.75735931 C18.5857864,10.1005051 18.5857864,13.8994949 16.2426407,16.2426407 C15.8521164,16.633165 15.8521164,17.26633 16.2426407,17.6568542 C16.633165,18.0473785 17.26633,18.0473785 17.6568542,17.6568542 Z" fill-rule="nonzero"></path>\n    <path fill="currentColor" d="M20.4852814,20.4852814 C25.1715729,15.7989899 25.1715729,8.20101013 20.4852814,3.51471863 C20.0947571,3.12419433 19.4615921,3.12419433 19.0710678,3.51471863 C18.6805435,3.90524292 18.6805435,4.5384079 19.0710678,4.92893219 C22.9763107,8.83417511 22.9763107,15.1658249 19.0710678,19.0710678 C18.6805435,19.4615921 18.6805435,20.0947571 19.0710678,20.4852814 C19.4615921,20.8758057 20.0947571,20.8758057 20.4852814,20.4852814 Z" fill-rule="nonzero"></path>\n    <path fill="currentColor" d="M1.0093689,8.0749622 C0.451909848,8.0749622 0,8.51944308 0,9.06903369 L0,14.9298135 C0,15.478824 0.443353176,15.923885 1.0093689,15.923885 L4,15.923885 L9.37646484,19.6916936 C10.2772423,20.3229555 11,19.9530982 11,18.872049 L11,5.1267982 C11,4.0451514 10.2731186,3.67878158 9.37646484,4.30715352 L4,8.0749622 L1.0093689,8.0749622 Z"></path>\n</svg>\n';
};

exports.default = volumeHighIcon;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".pf-player-container {\n  width: 100%;\n  height: 100%;\n  user-select: none;\n  display: inherit;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  font-family: \"Arial\";\n  overflow: hidden; }\n  .pf-player-container:focus {\n    border: none;\n    outline-width: 0; }\n  .pf-player-container .pf-default-wrapper {\n    background-color: black;\n    position: relative;\n    width: 100%;\n    height: 100%; }\n  .pf-player-container .pf-player, .pf-player-container .pf-player video, .pf-player-container .pf-player audio {\n    width: 100%;\n    height: 100%;\n    display: inherit; }\n  .pf-player-container .pf-player .pf-audio-image {\n    height: 100%;\n    margin: 0 auto;\n    text-align: center;\n    display: block; }\n  .pf-player-container .pf-ads {\n    width: 100%;\n    height: 100%;\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0; }\n  .pf-player-container .pf-controls {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0px; }\n\n.mstr-hide-controls {\n  animation: hide-bars-animation 0.4s forwards; }\n\n.pf-ui-element-hidden {\n  visibility: hidden !important;\n  width: 0px !important; }\n\n.mstr-container,\n.mstr-container * {\n  box-sizing: border-box; }\n\n.mstr-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%; }\n\n.mstr-bottombar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  padding: 15px;\n  width: 100%;\n  background-image: linear-gradient(to top, black 0%, rgba(0, 0, 0, 0.738) 19%, rgba(0, 0, 0, 0.541) 34%, rgba(0, 0, 0, 0.382) 47%, rgba(0, 0, 0, 0.278) 56.5%, rgba(0, 0, 0, 0.194) 65%, rgba(0, 0, 0, 0.126) 73%, rgba(0, 0, 0, 0.075) 80.2%, rgba(0, 0, 0, 0.042) 86.1%, rgba(0, 0, 0, 0.021) 91%, rgba(0, 0, 0, 0.008) 95.2%, rgba(0, 0, 0, 0.002) 98.2%, transparent 100%); }\n\n.mstr-centerbar {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  transform: translateY(-50%);\n  text-align: center; }\n\n.mstr-items {\n  display: table;\n  position: relative; }\n\n.mstr-item {\n  color: white;\n  display: table-cell;\n  width: auto;\n  vertical-align: middle; }\n  .mstr-item > div {\n    padding: 0 10px; }\n    .mstr-item > div.mstr-standard-uiElementHidden {\n      padding: 0; }\n\n.mstr-item--fill {\n  width: 100%; }\n\n@keyframes show-bars-animation {\n  0% {\n    width: 0;\n    opacity: 0; }\n  1% {\n    width: 100%;\n    opacity: 0.01; }\n  100% {\n    width: 100%;\n    opacity: 1; } }\n\n@keyframes hide-bars-animation {\n  0% {\n    width: 100%;\n    opacity: 1; }\n  99% {\n    width: 100%;\n    opacity: 0.01; }\n  100% {\n    width: 0;\n    opacity: 0; } }\n", ""]);

// exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "._3-7jdtXGk4-IHrW24dLF4t {\n  display: block; }\n", ""]);

// exports
exports.locals = {
	"button": "_3-7jdtXGk4-IHrW24dLF4t"
};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "._2DjGpA6bpztzCIAHvLvgPU {\n  width: 62px; }\n", ""]);

// exports
exports.locals = {
	"container": "_2DjGpA6bpztzCIAHvLvgPU"
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "._2BkoXnFkGWrot4AcrmAdbW {\n  cursor: pointer;\n  pointer-events: all;\n  color: #FFF; }\n\n._1L-Qm5xHQu3dqpQbSGrwcf {\n  cursor: not-allowed;\n  pointer-events: none;\n  color: #FFF;\n  opacity: .8; }\n\n._1Svz3o9fO5ftw5nQmQvFqL {\n  display: none;\n  visibility: hidden; }\n\n._1nCAdn1flNYjKcqsd3vMgY {\n  display: block;\n  width: 30px;\n  height: 30px;\n  color: #FFF; }\n\n._2GjwLTf0ojMGQEkCzNc9Qz {\n  position: relative; }\n\n._1rkEbgdPOWi_wGc1u2I8d- {\n  position: absolute;\n  right: 0;\n  bottom: 100%;\n  padding-bottom: 15px; }\n  ._1rkEbgdPOWi_wGc1u2I8d-._1RtEWhu3XHXTFoQMs8Bq11 {\n    display: none; }\n\n._3h9pYFHPU_F9zDvpJizvfB {\n  padding: 6px 20px;\n  background-color: rgba(0, 0, 0, 0.8);\n  border-radius: 5px; }\n\n._3rREDsf0Lm5GHZCgo2IN2x {\n  color: rgba(255, 255, 255, 0.8);\n  padding: 10px 10px;\n  border-bottom: 1px solid #FFF; }\n  ._3rREDsf0Lm5GHZCgo2IN2x:last-child {\n    border-bottom: none; }\n  ._3rREDsf0Lm5GHZCgo2IN2x._1casQPYrLP1EAJDS5j5lKU {\n    color: #FFF; }\n", ""]);

// exports
exports.locals = {
	"uiElementActive": "_2BkoXnFkGWrot4AcrmAdbW",
	"uiElementInactive": "_1L-Qm5xHQu3dqpQbSGrwcf",
	"uiElementHidden": "_1Svz3o9fO5ftw5nQmQvFqL",
	"svg": "_1nCAdn1flNYjKcqsd3vMgY",
	"element": "_2GjwLTf0ojMGQEkCzNc9Qz",
	"qualitySelector": "_1rkEbgdPOWi_wGc1u2I8d-",
	"isClosed": "_1RtEWhu3XHXTFoQMs8Bq11",
	"qualitySelectorOptions": "_3h9pYFHPU_F9zDvpJizvfB",
	"qualitySelectorOption": "_3rREDsf0Lm5GHZCgo2IN2x",
	"isActive": "_1casQPYrLP1EAJDS5j5lKU"
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "._3HNF4mRUnlhEUDRmRaL1FM {\n  cursor: pointer;\n  pointer-events: all;\n  color: #FFF; }\n\n._1fkLzlfvHZyF5l8gNKYlco {\n  cursor: not-allowed;\n  pointer-events: none;\n  color: #FFF;\n  opacity: .8; }\n\n._9TlMiMIkS6_5UIbC4_9Z_ {\n  display: none;\n  visibility: hidden; }\n\n.WpxVeEvSo_e6KuqcoxKKr {\n  display: block;\n  width: 30px;\n  height: 30px;\n  color: #FFF; }\n\n._2SLCqo9Zre3N_OuQBP5thQ {\n  padding: 10px 0;\n  position: relative;\n  box-sizing: content-box; }\n\n._1l06Jxfs-cgi6Wcnpf8tmc {\n  height: 3px;\n  position: relative; }\n\n._2FVb2TWUbZctFiLbyVV9wY {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 9; }\n\n._3KzTOKXIZbO-JnBB32uw9c {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  transform-origin: left center; }\n  ._3KzTOKXIZbO-JnBB32uw9c.EFV1Lvft1DlZC6-WbFj1r {\n    pointer-events: none;\n    background-color: #FFF; }\n  ._3KzTOKXIZbO-JnBB32uw9c.-ZCQKxdC1HEEx4bPpfAfL {\n    pointer-events: none;\n    background-color: rgba(255, 255, 255, 0.2); }\n  ._3KzTOKXIZbO-JnBB32uw9c._3tvc80_K6TWURvVOO4MMoJ {\n    pointer-events: none;\n    background-color: #19c3dd; }\n  ._3KzTOKXIZbO-JnBB32uw9c._39O-7yA5EIqvAL-b7vTyf {\n    pointer-events: none;\n    background-color: #19c3dd; }\n\n._2iqZwCTAxrfF5VqEChdLit {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  background-color: #FFF;\n  transform: translate(-50%, -25%); }\n", ""]);

// exports
exports.locals = {
	"uiElementActive": "_3HNF4mRUnlhEUDRmRaL1FM",
	"uiElementInactive": "_1fkLzlfvHZyF5l8gNKYlco",
	"uiElementHidden": "_9TlMiMIkS6_5UIbC4_9Z_",
	"svg": "WpxVeEvSo_e6KuqcoxKKr",
	"wrapper": "_2SLCqo9Zre3N_OuQBP5thQ",
	"inner": "_1l06Jxfs-cgi6Wcnpf8tmc",
	"padding": "_2FVb2TWUbZctFiLbyVV9wY",
	"seekbar": "_3KzTOKXIZbO-JnBB32uw9c",
	"duration": "EFV1Lvft1DlZC6-WbFj1r",
	"buffered": "-ZCQKxdC1HEEx4bPpfAfL",
	"fill": "_3tvc80_K6TWURvVOO4MMoJ",
	"highlight": "_39O-7yA5EIqvAL-b7vTyf",
	"seekDot": "_2iqZwCTAxrfF5VqEChdLit"
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "._1NqeSe-8TiiitC92PrK5V6 {\n  cursor: pointer;\n  pointer-events: all;\n  color: #FFF; }\n\n.gSKNiCBwJzI_CuN4a5PXT {\n  cursor: not-allowed;\n  pointer-events: none;\n  color: #FFF;\n  opacity: .8; }\n\n._1NmNo3BcjIiEb9F1ore73P {\n  display: none;\n  visibility: hidden; }\n\n.wIaEO9c3JIYl_RHqMklus {\n  display: block;\n  width: 30px;\n  height: 30px;\n  color: #FFF; }\n\n._2PNu7_mVapP8YTuo16N25l {\n  color: #FFF;\n  position: absolute;\n  left: 0;\n  bottom: 100%;\n  color: white;\n  pointer-events: none; }\n  ._2PNu7_mVapP8YTuo16N25l ._2-pCqztMpeQXeI3qV-zMa6 {\n    position: relative;\n    display: block;\n    padding: 5px;\n    background-color: rgba(0, 0, 0, 0.8);\n    color: #FFF;\n    transform: translateY(-16px);\n    opacity: 1;\n    transition: all 150ms ease-in-out;\n    font-size: .8em; }\n    ._2PNu7_mVapP8YTuo16N25l ._2-pCqztMpeQXeI3qV-zMa6:after {\n      content: '';\n      position: absolute;\n      left: 50%;\n      bottom: -10px;\n      transform: translateX(-50%);\n      display: block;\n      border-top: 5px rgba(0, 0, 0, 0.8) solid;\n      border-bottom: 5px transparent solid;\n      border-left: 6px transparent solid;\n      border-right: 6px transparent solid; }\n  ._2PNu7_mVapP8YTuo16N25l._2pqaVb1dIsg92NjxMjnEDm ._2-pCqztMpeQXeI3qV-zMa6 {\n    transform: translateY(0);\n    opacity: 0; }\n", ""]);

// exports
exports.locals = {
	"uiElementActive": "_1NqeSe-8TiiitC92PrK5V6",
	"uiElementInactive": "gSKNiCBwJzI_CuN4a5PXT",
	"uiElementHidden": "_1NmNo3BcjIiEb9F1ore73P",
	"svg": "wIaEO9c3JIYl_RHqMklus",
	"container": "_2PNu7_mVapP8YTuo16N25l",
	"previewTime": "_2-pCqztMpeQXeI3qV-zMa6",
	"isHidden": "_2pqaVb1dIsg92NjxMjnEDm"
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "._1d0zv-YPmo1Ldno5TIUoEa {\n  cursor: pointer;\n  pointer-events: all;\n  color: #FFF; }\n\n._20AZqi0DFj0l7W2MSMC0K {\n  cursor: not-allowed;\n  pointer-events: none;\n  color: #FFF;\n  opacity: .8; }\n\n.k7AdDQ9UeafLwrS3oMDMB {\n  display: none;\n  visibility: hidden; }\n\n.Zhc3tWX4acnrOslNR6TeC {\n  display: block;\n  width: 30px;\n  height: 30px;\n  color: #FFF; }\n\n._3evMdf81zHb9adbp8ayXKg {\n  text-align: center;\n  display: inline-block; }\n\n._1_0YxXFDEW3QGMIEn1l0UW {\n  display: inline-block;\n  width: 3em;\n  height: 3em;\n  border-radius: 50%;\n  border: 3px solid #FFF;\n  border-bottom-color: transparent;\n  background-color: rgba(0, 0, 0, 0.4);\n  animation: _3dUNERw2qIIYEGsihFBEZq 1s linear forwards infinite;\n  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.4); }\n\n._34DF9shkBnJYlpUMBOhf84 {\n  font-size: 1em;\n  margin-top: .4em;\n  padding: .4em 1em;\n  color: #FFF;\n  background-color: rgba(0, 0, 0, 0.4);\n  border-radius: 5px; }\n\n._2VIkdLXXt3VfC7JWCLHXfq {\n  display: none; }\n\n@keyframes _3dUNERw2qIIYEGsihFBEZq {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(360deg); } }\n", ""]);

// exports
exports.locals = {
	"uiElementActive": "_1d0zv-YPmo1Ldno5TIUoEa",
	"uiElementInactive": "_20AZqi0DFj0l7W2MSMC0K",
	"uiElementHidden": "k7AdDQ9UeafLwrS3oMDMB",
	"svg": "Zhc3tWX4acnrOslNR6TeC",
	"container": "_3evMdf81zHb9adbp8ayXKg",
	"spinner": "_1_0YxXFDEW3QGMIEn1l0UW",
	"spinSpinner": "_3dUNERw2qIIYEGsihFBEZq",
	"message": "_34DF9shkBnJYlpUMBOhf84",
	"hidden": "_2VIkdLXXt3VfC7JWCLHXfq"
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "._3MmM1N0M8WgUq3eoB_zgHY {\n  display: block; }\n", ""]);

// exports
exports.locals = {
	"button": "_3MmM1N0M8WgUq3eoB_zgHY"
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "._1zZz1N5ZvuI8BZagfW2qSj {\n  display: block; }\n", ""]);

// exports
exports.locals = {
	"button": "_1zZz1N5ZvuI8BZagfW2qSj"
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "._3eQbS0Zn_3j-9Xm9wBsK1P {\n  white-space: nowrap; }\n\n._2B9-HeFA7C4xARoMI9cCKn {\n  display: inline-block;\n  padding: 0 .1em; }\n", ""]);

// exports
exports.locals = {
	"container": "_3eQbS0Zn_3j-9Xm9wBsK1P",
	"seperator": "_2B9-HeFA7C4xARoMI9cCKn"
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".v5t06TRsOeMUDMQnYoyPM {\n  cursor: pointer;\n  pointer-events: all;\n  color: #FFF; }\n\n.Q1Suh1PnogvUjYp5fDcg9 {\n  cursor: not-allowed;\n  pointer-events: none;\n  color: #FFF;\n  opacity: .8; }\n\n._1M8QRzyDMWTYCenJKZ4c5t {\n  display: none;\n  visibility: hidden; }\n\n.uJYQ0qTl7XvHLKoiCSy4e {\n  display: block;\n  width: 30px;\n  height: 30px;\n  color: #FFF; }\n\n._2GflfmqwaYB2qLzX2ey8p8 {\n  position: relative; }\n\n._16fXrOcWTt7zR7RfJV-cDc {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  padding-bottom: 15px; }\n  ._16fXrOcWTt7zR7RfJV-cDc._3g6zNZaiv9EzypziOuhuoH {\n    display: none; }\n\n._2de5BsC_TROol822hJDj2c {\n  padding: 16px 18px;\n  background-color: rgba(0, 0, 0, 0.8);\n  border-radius: 5px; }\n\n.urVWpavSqihMZbXG2J7sk {\n  position: relative;\n  height: 100px;\n  width: 3px;\n  background-color: #FFF; }\n\n._2Xy-XF0I43HeNHwPvSg2qI {\n  position: relative;\n  height: 100%;\n  background-color: #19c3dd;\n  transform-origin: bottom center;\n  pointer-events: none; }\n\n._1JBxjTYI2aPUth7YdIJH7r {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  background-color: #FFF;\n  transform: translate(-50%, 50%);\n  pointer-events: none; }\n", ""]);

// exports
exports.locals = {
	"uiElementActive": "v5t06TRsOeMUDMQnYoyPM",
	"uiElementInactive": "Q1Suh1PnogvUjYp5fDcg9",
	"uiElementHidden": "_1M8QRzyDMWTYCenJKZ4c5t",
	"svg": "uJYQ0qTl7XvHLKoiCSy4e",
	"volume": "_2GflfmqwaYB2qLzX2ey8p8",
	"container": "_16fXrOcWTt7zR7RfJV-cDc",
	"isClosed": "_3g6zNZaiv9EzypziOuhuoH",
	"inner": "_2de5BsC_TROol822hJDj2c",
	"volumeBar": "urVWpavSqihMZbXG2J7sk",
	"volumeBarFill": "_2Xy-XF0I43HeNHwPvSg2qI",
	"volumeBarFigure": "_1JBxjTYI2aPUth7YdIJH7r"
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".OZ4P-74HjncIZPPMIe1FP {\n  cursor: pointer;\n  pointer-events: all;\n  color: #FFF; }\n\n._K2hZrPaL1ViV8PoFwKqV {\n  cursor: not-allowed;\n  pointer-events: none;\n  color: #FFF;\n  opacity: .8; }\n\n._1-mv6TpMQsZ7SVRwjGyts1 {\n  display: none;\n  visibility: hidden; }\n\n._3M5Ou7Yb--qH26Gz3F-Plp {\n  display: block;\n  width: 30px;\n  height: 30px;\n  color: #FFF; }\n", ""]);

// exports
exports.locals = {
	"uiElementActive": "OZ4P-74HjncIZPPMIe1FP",
	"uiElementInactive": "_K2hZrPaL1ViV8PoFwKqV",
	"uiElementHidden": "_1-mv6TpMQsZ7SVRwjGyts1",
	"svg": "_3M5Ou7Yb--qH26Gz3F-Plp"
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(46);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(47);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(48);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(49);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(51);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(52);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(53);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(54);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(55);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(56);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(57);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {"sourceMap":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = {"name":"@meisterplayer/plugin-htmlui","version":"5.6.2","description":"HTML based userinterface with preconfigured elements. Can be used to create your own userinterface","main":"dist/HtmlUi.js","keywords":["meister","plugin","ui","custom"],"scripts":{"lint":"eslint ./src/js","test":"jest","test:coverage":"jest --coverage","build":"gulp build","dist":"gulp build:min && gulp build:dist"},"author":"Triple","license":"Apache-2.0","devDependencies":{"@meisterplayer/meister-mock":"^1.0.0","babel-preset-es2015":"^6.24.1","babel-preset-es2017":"^6.24.1","gulp":"^3.9.1","jest":"^20.0.4","meister-gulp-webpack-tasks":"^1.0.11","meister-js-dev":"^3.1.0","yargs":"^8.0.1"},"jest":{"moduleNameMapper":{"^.+\\.(s?css|less)$":"<rootDir>/__mocks__/styleStub.js"}}}

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(9);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// dist/HtmlUi.js